/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} publicWidgetClientFailedToReceiveATokenForWidgetAuthenticationFromHostSiteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Client ID of the user
* @property {string} locale - Answers language
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
**/
/**
 * Name: Public (Widget) - Client failed to receive a Token for Widget authentication from host site. Evid: 2253.
 * Event description: Client failed to receive a Token for Widget authentication from host site.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Client ID of the user
 *
 * locale - Type: string. Desc: Answers language
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 * @param {publicWidgetClientFailedToReceiveATokenForWidgetAuthenticationFromHostSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetClientFailedToReceiveATokenForWidgetAuthenticationFromHostSite = function (params) {
    return { evid: 2253, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralPageLoadAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {string} module - module
* @property {Url} page_url - page_url
* @property {string} permission_level - User's permission level
* @property {string} section_key - specific section that user tried to change
* @property {GUID} tenant_id - tenant_id
* @property {GUID} ticket_id - null
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (General) - Page Load Attempt. Evid: 1950.
 * Event description: General event - like "page view". This event is sent after the app is already loaded, and the specific page/module is starting to load.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * module - Type: string. Desc: module
 *
 * page_url - Type: url. Desc: page_url
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * section_key - Type: string. Desc: specific section that user tried to change
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * ticket_id - Type: guid.
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appGeneralPageLoadAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralPageLoadAttempt = function (params) {
    return { evid: 1950, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSeeAllResultsParams
* @property {GUID} answers_brand_id - answers brand id
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} result_article_id_1 - result_article_id_1
* @property {GUID} result_article_id_2 - result_article_id_2
* @property {GUID} result_article_id_3 - result_article_id_3
* @property {string} search_term - search_term
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Click the (see all results) link. Evid: 2007.
 * Event description: click the (see all results) link (similar to evid 522 in src 4).

 * answers_brand_id - Type: guid. Desc: answers brand id
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * result_article_id_1 - Type: guid. Desc: result_article_id_1
 *
 * result_article_id_2 - Type: guid. Desc: result_article_id_2
 *
 * result_article_id_3 - Type: guid. Desc: result_article_id_3
 *
 * search_term - Type: string. Desc: search_term
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicSeeAllResultsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSeeAllResults = function (params) {
    return { evid: 2007, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralPageLoadFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} errorReason - reason for fail
* @property {string} lang - answers language
* @property {string} module - module
* @property {Url} page_url - page_url
* @property {string} permission_level - User's permission level
* @property {string} section_key - specific section that user tried to change
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (General) - Page Load Fail. Evid: 1952.
 * Event description: General event - like "page view".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * errorReason - Type: string. Desc: reason for fail
 *
 * lang - Type: string. Desc: answers language
 *
 * module - Type: string. Desc: module
 *
 * page_url - Type: url. Desc: page_url
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * section_key - Type: string. Desc: specific section that user tried to change
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appGeneralPageLoadFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralPageLoadFail = function (params) {
    return { evid: 1952, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} answersBannerViewParams
* @property {string} banner_text - banner text
* @property {GUID} answers_brand_id - null
* @property {string} banner_language - banner_language
* @property {string} banner_name - null
* @property {GUID} client_id - null
* @property {string} lang - Answers language
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: Answers Banner View. Evid: 4908.
 * Event description: Fired when the user enters a page that has a banner.

 * banner_text - Type: string. Desc: banner text
 *
 * answers_brand_id - Type: guid.
 *
 * banner_language - Type: string. Desc: banner_language
 *
 * banner_name - Type: string.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {answersBannerViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var answersBannerView = function (params) {
    return { evid: 4908, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetClientReceivesATokenForWidgetAuthenticationFromHostSiteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Client ID of the user
* @property {string} locale - Answers language
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
**/
/**
 * Name: Public (Widget) - Client receives a Token for Widget authentication from host site. Evid: 2252.
 * Event description: Widget Client receives a Token for Widget authentication from host site.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Client ID of the user
 *
 * locale - Type: string. Desc: Answers language
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 * @param {publicWidgetClientReceivesATokenForWidgetAuthenticationFromHostSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetClientReceivesATokenForWidgetAuthenticationFromHostSite = function (params) {
    return { evid: 2252, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSubmitTicketValidationErrorParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - null if form_source is = 1
* @property {GUID} client_id - client_id
* @property {string} description - Ticket content
* @property {boolean} error_in_costume_field - error_in_costume_field
* @property {boolean} error_in_description - Has error in description?
* @property {boolean} error_in_email - error_in_email
* @property {boolean} error_in_name - error_in_name
* @property {boolean} error_in_subject - Has error in subject?
* @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
* @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
* @property {boolean} is_attached - if there is an attachment
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} subject - Ticket subject
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - user_id
**/
/**
 * Name: Public - "Submit Ticket" - validation error. Evid: 2511.
 * Event description: Public - "Submit Ticket" - validation error.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: null if form_source is = 1
 *
 * client_id - Type: guid. Desc: client_id
 *
 * description - Type: string. Desc: Ticket content
 *
 * error_in_costume_field - Type: bool. Desc: error_in_costume_field
 *
 * error_in_description - Type: bool. Desc: Has error in description?
 *
 * error_in_email - Type: bool. Desc: error_in_email
 *
 * error_in_name - Type: bool. Desc: error_in_name
 *
 * error_in_subject - Type: bool. Desc: Has error in subject?
 *
 * form_source - Type: string. Desc: {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 *
 * is_after_suggestion - Type: bool. Desc: rather the user already clicked on a features article and clicked "No, I want to report my issue"
 *
 * is_attached - Type: bool. Desc: if there is an attachment
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * subject - Type: string. Desc: Ticket subject
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {publicSubmitTicketValidationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSubmitTicketValidationError = function (params) {
    return { evid: 2511, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsCreateNewFieldParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {string} source - {Fields manager, Widget contact form, Help center contact form}
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Create new field. Evid: 1400.
 * Event description: Click on the button "Create New Field".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Fields manager, Widget contact form, Help center contact form}
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {appSettingsTicketSettingsCustomFieldsCreateNewFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsCreateNewField = function (params) {
    return { evid: 1400, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsDeleteAReplyClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} content - reply's content
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - reply id
* @property {string} reply_type - {team note/reply}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Delete a reply click. Evid: 1012.
 * Event description: Click Delete a reply from a ticket. event is triggered from both Tickets and One Inbox modules,.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * content - Type: string. Desc: reply's content
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: reply id
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsDeleteAReplyClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsDeleteAReplyClick = function (params) {
    return { evid: 1012, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingRequestDemoWidgetSubmitRequestDemoParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - null
**/
/**
 * Name: Marketing  - "Request Demo" Widget - Submit Request Demo. Evid: 119.
 * Event description: The user fill all the inputs and submit the request to schedule a demo..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid.
 * @param {marketingRequestDemoWidgetSubmitRequestDemoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingRequestDemoWidgetSubmitRequestDemo = function (params) {
    return { evid: 119, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpFormValidationFailedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} campaign_id - the field will be deprecated
* @property {string} locale - Answers language- remove
* @property {GUID} marketing_id - field will be deprecated
* @property {string} permission_level - Level of permission of the performing user
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - A unique guid for sign up flow
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - null
**/
/**
 * Name: Marketing - Field validation failed in form. Evid: 102.
 * Event description: Form field validation failed- fired when filling up one of the forms: 1.create account form(sign Up) 2. Login 3. team invitation..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * campaign_id - Type: numeric. Desc: the field will be deprecated
 *
 * locale - Type: string. Desc: Answers language- remove
 *
 * marketing_id - Type: guid. Desc: field will be deprecated
 *
 * permission_level - Type: string. Desc: Level of permission of the performing user
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: A unique guid for sign up flow
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid.
 * @param {marketingSignUpFormValidationFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpFormValidationFailed = function (params) {
    return { evid: 102, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbFeaturedArticlesAddSelectedArticleClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - selected article id
* @property {string} article_name - selected article name
* @property {GUID} category_id - article's category id
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Featured articles - Add selected article click. Evid: 1116.
 * Event description: Click "add" after selecting the desired article to be featured.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: selected article id
 *
 * article_name - Type: string. Desc: selected article name
 *
 * category_id - Type: guid. Desc: article's category id
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbFeaturedArticlesAddSelectedArticleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbFeaturedArticlesAddSelectedArticleClick = function (params) {
    return { evid: 1116, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appWasabiAdvancedReportsCreateNewReportParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} reportName - report name
* @property {string} source_component - null
* @property {GUID} tenant_id - answers tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (Wasabi) - Advanced Reports - Create new report. Evid: 1331.
 * Event description: User Created new report - 2 options: Reports view / duplicate
after clicking on 'Create Report'.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * reportName - Type: string. Desc: report name
 *
 * source_component - Type: string.
 *
 * tenant_id - Type: guid. Desc: answers tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appWasabiAdvancedReportsCreateNewReportParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appWasabiAdvancedReportsCreateNewReport = function (params) {
    return { evid: 1331, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbFeaturedArticlesSearchAnArticleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {string} search_term - selected article name
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Featured articles - search an article. Evid: 1117.
 * Event description: search for a featured article.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * search_term - Type: string. Desc: selected article name
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbFeaturedArticlesSearchAnArticleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbFeaturedArticlesSearchAnArticle = function (params) {
    return { evid: 1117, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsChangeSuccessParams
* @property {GUID} answers_brand_id - null
* @property {string} change_content - json with all the changed information
* @property {string} changeType - {delete/create/update}
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {Url} page_url - page_url
* @property {string} section_key - specific section that user tried to change
* @property {string} source_name - hc-1 / hc-2
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (Settings) - Change success. Evid: 1451.
 * Event description: Change event attempt: save/toggle in the setting section.

 * answers_brand_id - Type: guid.
 *
 * change_content - Type: string. Desc: json with all the changed information
 *
 * changeType - Type: string. Desc: {delete/create/update}
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * page_url - Type: url. Desc: page_url
 *
 * section_key - Type: string. Desc: specific section that user tried to change
 *
 * source_name - Type: string. Desc: hc-1 / hc-2
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appSettingsChangeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsChangeSuccess = function (params) {
    return { evid: 1451, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpMarketoUpdateSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {Url} page_url - page_url
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - Answer's uuid
**/
/**
 * Name: Marketing (sign up) - Marketo update - Success. Evid: 127.
 * Event description: triggered: when finished update (with success) Marketo API after signup..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * page_url - Type: url. Desc: page_url
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: Answer's uuid
 * @param {marketingSignUpMarketoUpdateSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpMarketoUpdateSuccess = function (params) {
    return { evid: 127, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} devGeneralTwilioEventParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} data - data
* @property {GUID} item_id - Item ID
* @property {string} tab_id - persistent id for the open tab, to debug multiple tab issues
* @property {GUID} tenant_id - tenant ID
* @property {string} type - type
* @property {GUID} user_id - null
**/
/**
 * Name: Dev - General Twilio Event. Evid: 99.
 * Event description: This is a general event for data we get from Twilio. We use for QA and debug..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: data
 *
 * item_id - Type: guid. Desc: Item ID
 *
 * tab_id - Type: string. Desc: persistent id for the open tab, to debug multiple tab issues
 *
 * tenant_id - Type: guid. Desc: tenant ID
 *
 * type - Type: string. Desc: type
 *
 * user_id - Type: guid.
 * @param {devGeneralTwilioEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var devGeneralTwilioEvent = function (params) {
    return { evid: 99, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSelectSearchResultParams
* @property {string} answer - The selected answer
* @property {number} answer_index - index of answer (1,2,3,4,5..)
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - Article ID
* @property {GUID} category_id - Category ID
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} question - user's search terms (question)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {string} search_term - search term which lead to this answer
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - select search result. Evid: 2006.
 * Event description: click on answer (similar to evid 521 in src 4).

 * answer - Type: string. Desc: The selected answer
 *
 * answer_index - Type: numeric. Desc: index of answer (1,2,3,4,5..)
 *
 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: Article ID
 *
 * category_id - Type: guid. Desc: Category ID
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * question - Type: string. Desc: user's search terms (question)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * search_term - Type: string. Desc: search term which lead to this answer
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicSelectSearchResultParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSelectSearchResult = function (params) {
    return { evid: 2006, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamAddNewGroupMemberClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} group_id - group id
* @property {string} group_name - group name
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} source - {Edit group/New group}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Add new group member click. Evid: 1210.
 * Event description: Clicking the "+ New Team member" button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * group_id - Type: guid. Desc: group id
 *
 * group_name - Type: string. Desc: group name
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Edit group/New group}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamAddNewGroupMemberClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamAddNewGroupMemberClick = function (params) {
    return { evid: 1210, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingPageViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers Client ID
* @property {number} campaign_id - The field will be deprecated
* @property {string} locale - Answers language
* @property {GUID} marketing_id - The field will be deprecated
* @property {Url} page_url - URL of the current page
* @property {string} permission_level - Level of permission of the performing user
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - A unique guid for sign up flow
* @property {GUID} tenant_id - Tenant of the performing user
* @property {string} utm_campaign - Campaign Name (utm_campaign component in the url)
* @property {string} utm_source - Campaign Source (utm_source component in the url)
* @property {GUID} user_id - Answers User ID
* @property {GUID} wix_client_id - Wix Client (Anonymous) ID
* @property {GUID} wix_user_id - Wix User ID
**/
/**
 * Name: Marketing - Page view. Evid: 113.
 * Event description: Viewing a page in Answers Marketing Site..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers Client ID
 *
 * campaign_id - Type: numeric. Desc: The field will be deprecated
 *
 * locale - Type: string. Desc: Answers language
 *
 * marketing_id - Type: guid. Desc: The field will be deprecated
 *
 * page_url - Type: url. Desc: URL of the current page
 *
 * permission_level - Type: string. Desc: Level of permission of the performing user
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: A unique guid for sign up flow
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * utm_campaign - Type: string. Desc: Campaign Name (utm_campaign component in the url)
 *
 * utm_source - Type: string. Desc: Campaign Source (utm_source component in the url)
 *
 * user_id - Type: guid. Desc: Answers User ID
 *
 * wix_client_id - Type: guid. Desc: Wix Client (Anonymous) ID
 *
 * wix_user_id - Type: guid. Desc: Wix User ID
 * @param {marketingPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingPageView = function (params) {
    return { evid: 113, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLogInUserLoginAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers uuid
* @property {string} login_type - wix/ google / facebook/emial
* @property {Url} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {string} subdomain - answers subdomain
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - answers ID
**/
/**
 * Name: Marketing (Log In) - User Login Attempt. Evid: 114.
 * Event description: User attempt to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers uuid
 *
 * login_type - Type: string. Desc: wix/ google / facebook/emial
 *
 * page_url - Type: url. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * subdomain - Type: string. Desc: answers subdomain
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: answers ID
 * @param {marketingLogInUserLoginAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLogInUserLoginAttempt = function (params) {
    return { evid: 114, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicPageViewArticleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - article_id
* @property {string} article_name - article_name
* @property {string} article_type - {article/feature request/bug...}
* @property {GUID} category_id - category_id
* @property {string} category_name - category_name
* @property {GUID} client_id - client id
* @property {string} locale - Answers language
* @property {string} parent_url - parent_url (widget)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - help center/ widget id
* @property {string} source_name - source_name
* @property {string} source_type - {Help center/widget}
* @property {GUID} sub_category_id - sub_category_id
* @property {string} sub_category_name - sub_category_name
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Page view (article). Evid: 1997.
 * Event description: Article - page view.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: article_id
 *
 * article_name - Type: string. Desc: article_name
 *
 * article_type - Type: string. Desc: {article/feature request/bug...}
 *
 * category_id - Type: guid. Desc: category_id
 *
 * category_name - Type: string. Desc: category_name
 *
 * client_id - Type: guid. Desc: client id
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: parent_url (widget)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: help center/ widget id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: {Help center/widget}
 *
 * sub_category_id - Type: guid. Desc: sub_category_id
 *
 * sub_category_name - Type: string. Desc: sub_category_name
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicPageViewArticleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicPageViewArticle = function (params) {
    return { evid: 1997, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} agentDeclinesCall4906Params
* @property {GUID} answers_brand_id - null
* @property {GUID} callid - Call ID of the declined call
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Agent Declines Call. Evid: 4906.
 * Event description: Triggers when an agent delines a call, returns Call Id and Tenant ID,
Agent ID as implicit UUID field..

 * answers_brand_id - Type: guid.
 *
 * callid - Type: guid. Desc: Call ID of the declined call
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {agentDeclinesCall4906Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var agentDeclinesCall4906 = function (params) {
    return { evid: 4906, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsCreateATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Create a ticket. Evid: 1006.
 * Event description: create a ticket with all its details - click "Create ticket" blue button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTicketsCreateATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsCreateATicket = function (params) {
    return { evid: 1006, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsAddReplyAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
* @property {string} reply_type - {team note/reply}
* @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (Tickets) - Add reply - attempt. Evid: 1023.
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_and_go_to_tickets_list - Type: bool. Desc: true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * resolution - Type: string. Desc: what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appTicketsAddReplyAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsAddReplyAttempt = function (params) {
    return { evid: 1023, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsLinkArticleToATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - linked article id
* @property {string} article_name - linked article name
* @property {string} attach_method - article attachment method (immediate/paste-link/paste-content)
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} order_location - article order location in search/suggestions
* @property {string} origin_name - source name (search/suggestion/create ticket)
* @property {string} search_term - the string used for searching relevant articles (input search term/ticket subject)
* @property {string} suggested_article_ids - IDs of all the articles that appeared in the "suggestions component"
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - related ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Link article to a ticket. Evid: 1001.
 * Event description: Linking an article to a ticket.event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: linked article id
 *
 * article_name - Type: string. Desc: linked article name
 *
 * attach_method - Type: string. Desc: article attachment method (immediate/paste-link/paste-content)
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * order_location - Type: string. Desc: article order location in search/suggestions
 *
 * origin_name - Type: string. Desc: source name (search/suggestion/create ticket)
 *
 * search_term - Type: string. Desc: the string used for searching relevant articles (input search term/ticket subject)
 *
 * suggested_article_ids - Type: string. Desc: IDs of all the articles that appeared in the "suggestions component"
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: related ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsLinkArticleToATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsLinkArticleToATicket = function (params) {
    return { evid: 1001, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumBlocksPremiumIncentiveContactUsClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the blocked feature
* @property {boolean} is_eligible - Is the user eligible to buy a premium plan
* @property {boolean} is_premium - Is the tenant Premium or Free
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Blocks - Premium Incentive "Contact Us" Click. Evid: 1855.
 * Event description: A user clicks on the "Contact Us" button in a premium incentive of a blocked premium feature.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the blocked feature
 *
 * is_eligible - Type: bool. Desc: Is the user eligible to buy a premium plan
 *
 * is_premium - Type: bool. Desc: Is the tenant Premium or Free
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumBlocksPremiumIncentiveContactUsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumBlocksPremiumIncentiveContactUsClick = function (params) {
    return { evid: 1855, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbFeaturedArticlesRemoveArticleClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - selected article id
* @property {string} article_name - selected article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Featured articles - remove article click. Evid: 1118.
 * Event description: click "remove" button.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: selected article id
 *
 * article_name - Type: string. Desc: selected article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbFeaturedArticlesRemoveArticleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbFeaturedArticlesRemoveArticleClick = function (params) {
    return { evid: 1118, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} agentDeclinesCall4903Params
* @property {GUID} answers_brand_id - Tenant ID (deprecated)
* @property {GUID} callid - Call ID of the declined call
* @property {GUID} client_id - (deprecated)
* @property {GUID} tenant_id - Answers Tenant ID
* @property {GUID} user_id - (deprecated)
**/
/**
 * Name: Agent Declines Call - Deprecated. Evid: 4903.
 * Event description: Agent clicks the decline button of a call reserve attempt.

 * answers_brand_id - Type: guid. Desc: Tenant ID (deprecated)
 *
 * callid - Type: guid. Desc: Call ID of the declined call
 *
 * client_id - Type: guid. Desc: (deprecated)
 *
 * tenant_id - Type: guid. Desc: Answers Tenant ID
 *
 * user_id - Type: guid. Desc: (deprecated)
 * @param {agentDeclinesCall4903Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var agentDeclinesCall4903 = function (params) {
    return { evid: 4903, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbCategoriesDeleteCategoryParams
* @property {GUID} answers_brand_id - null
* @property {GUID} category_id - Category ID
* @property {string} category_name - User's entered value for category
* @property {GUID} client_id - null
* @property {boolean} is_complete - if no articles inside - this will be "1". else "0" (an error will pop-up)
* @property {string} lang - answers language
* @property {GUID} parent_guid - If category - null, if subcategory - category's id
* @property {string} permission_level - User's permission level
* @property {string} source - {side bar/main screen}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Categories - Delete category click. Evid: 1114.
 * Event description: Click Delete category from the category menu.

 * answers_brand_id - Type: guid.
 *
 * category_id - Type: guid. Desc: Category ID
 *
 * category_name - Type: string. Desc: User's entered value for category
 *
 * client_id - Type: guid.
 *
 * is_complete - Type: bool. Desc: if no articles inside - this will be "1". else "0" (an error will pop-up)
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: If category - null, if subcategory - category's id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {side bar/main screen}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbCategoriesDeleteCategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbCategoriesDeleteCategory = function (params) {
    return { evid: 1114, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsAttachmentAddedToReplyParams
* @property {GUID} answers_brand_id - null
* @property {string} attachment_type - attachment file type
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - saved reply id
* @property {string} source - {team note/reply/create ticket}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Attachment added to reply. Evid: 1016.
 * Event description: Add attachment to reply. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * attachment_type - Type: string. Desc: attachment file type
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: saved reply id
 *
 * source - Type: string. Desc: {team note/reply/create ticket}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsAttachmentAddedToReplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsAttachmentAddedToReply = function (params) {
    return { evid: 1016, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicPageViewErrorParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Client ID
* @property {string} errorReason - Error Reason
* @property {string} locale - Answers language
* @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
* @property {Url} page_url - The page's URL
* @property {string} parent_url - parent_url (widget)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - examples: {widget_123, yotpo_help_center1...}
* @property {string} source_type - {help center/widget}
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - user_id
**/
/**
 * Name: Public - Page view error. Evid: 2009.
 * Event description: page view error.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Client ID
 *
 * errorReason - Type: string. Desc: Error Reason
 *
 * locale - Type: string. Desc: Answers language
 *
 * page_type - Type: string. Desc: the type of the viewed page (for ex. home page, article, ticket..)
 *
 * page_url - Type: url. Desc: The page's URL
 *
 * parent_url - Type: string. Desc: parent_url (widget)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: examples: {widget_123, yotpo_help_center1...}
 *
 * source_type - Type: string. Desc: {help center/widget}
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: user_id
 * @param {publicPageViewErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicPageViewError = function (params) {
    return { evid: 2009, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpMarketoUpdateFailedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {Url} page_url - page_url
* @property {GUID} tenant_id - tenant_id
* @property {GUID} userId - Answers' uuid
* @property {GUID} user_id - null
**/
/**
 * Name: Marketing (sign up) - Marketo update - Failed. Evid: 128.
 * Event description: triggered: when finished update (with fail) Marketo API after signup..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * page_url - Type: url. Desc: page_url
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * userId - Type: guid. Desc: Answers' uuid
 *
 * user_id - Type: guid.
 * @param {marketingSignUpMarketoUpdateFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpMarketoUpdateFailed = function (params) {
    return { evid: 128, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsOpenCccModalParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} current_balance - Current CCC balance
* @property {boolean} is_premium - Is the tenant Premium or Free
* @property {string} origin - CCC modal origin
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Open CCC Modal. Evid: 1861.
 * Event description: Call Center Credits (CCC) modal lightbox appears successfully.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * current_balance - Type: string. Desc: Current CCC balance
 *
 * is_premium - Type: bool. Desc: Is the tenant Premium or Free
 *
 * origin - Type: string. Desc: CCC modal origin
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsOpenCccModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsOpenCccModal = function (params) {
    return { evid: 1861, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingClickSubmitSignUpFormParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers client ID
* @property {number} campaign_id - DEPRECATE
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - Answers uuid
**/
/**
 * Name: Marketing (Sign Up) - Submit Sign Up - first step. Evid: 103.
 * Event description: User attempt to submit the sign- up form..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers client ID
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 * @param {marketingClickSubmitSignUpFormParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingClickSubmitSignUpForm = function (params) {
    return { evid: 103, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appWasabiAdvancedReportsReportSubscriptionParams
* @property {GUID} answers_brand_id - null
* @property {string} button_name - Subscribe for Updates / Edit Subscription
* @property {GUID} client_id - null
* @property {string} day - Sunday, Monday, Tuesday.. etc
* @property {string} frequency - Daily / Weekly / Monthly
* @property {string} hour - null
* @property {string} message - email message
* @property {string} reportName - null
* @property {string} subject - email subject
* @property {GUID} tenant_id - answers tenant_id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Wasabi) - Advanced Reports - Report Subscription. Evid: 1333.


 * answers_brand_id - Type: guid.
 *
 * button_name - Type: string. Desc: Subscribe for Updates / Edit Subscription
 *
 * client_id - Type: guid.
 *
 * day - Type: string. Desc: Sunday, Monday, Tuesday.. etc
 *
 * frequency - Type: string. Desc: Daily / Weekly / Monthly
 *
 * hour - Type: string.
 *
 * message - Type: string. Desc: email message
 *
 * reportName - Type: string.
 *
 * subject - Type: string. Desc: email subject
 *
 * tenant_id - Type: guid. Desc: answers tenant_id
 *
 * user_id - Type: guid.
 * @param {appWasabiAdvancedReportsReportSubscriptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appWasabiAdvancedReportsReportSubscription = function (params) {
    return { evid: 1333, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsPressButtonCreateTicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Press button + Create ticket. Evid: 1005.
 * Event description: Press the button to + Create ticket.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTicketsPressButtonCreateTicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsPressButtonCreateTicket = function (params) {
    return { evid: 1005, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbMoveAssignSubcategoryParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {GUID} dest_parent_id - selected category/subcategory. if null than it is now a category
* @property {string} lang - answers language
* @property {string} method - {menu, drag, api...}
* @property {GUID} orig_parent_id - current category/subcategory
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {number} ts - amount of time (milliseconds) since save process started
* @property {GUID} user_id - uuid
**/
/**
 * Name: App (KB) - Move/Assign subcategory. Evid: 1122.
 * Event description: Assign a subcategory to a different category or make it its own category.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * dest_parent_id - Type: guid. Desc: selected category/subcategory. if null than it is now a category
 *
 * lang - Type: string. Desc: answers language
 *
 * method - Type: string. Desc: {menu, drag, api...}
 *
 * orig_parent_id - Type: guid. Desc: current category/subcategory
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ts - Type: numeric. Desc: amount of time (milliseconds) since save process started
 *
 * user_id - Type: guid. Desc: uuid
 * @param {appKbMoveAssignSubcategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbMoveAssignSubcategory = function (params) {
    return { evid: 1122, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsAddReplyFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} failReason - fail_reason
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
* @property {string} reply_type - {team note/reply}
* @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (Tickets) - Add reply - fail. Evid: 1024.
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * failReason - Type: string. Desc: fail_reason
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_and_go_to_tickets_list - Type: bool. Desc: true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * resolution - Type: string. Desc: what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appTicketsAddReplyFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsAddReplyFail = function (params) {
    return { evid: 1024, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsClickOnAnIconParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} icon_type - {emoji, KB, attachment, saved replies...}
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - saved reply id
* @property {string} source - {team note/reply/create ticket}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Click on an icon. Evid: 1015.
 * Event description: Click on one of the icons in the reply. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * icon_type - Type: string. Desc: {emoji, KB, attachment, saved replies...}
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: saved reply id
 *
 * source - Type: string. Desc: {team note/reply/create ticket}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsClickOnAnIconParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsClickOnAnIcon = function (params) {
    return { evid: 1015, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerCheckoutFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Checkout Fail. Evid: 1831.
 * Event description: User fails to checkout - Zuora iframe cannot be rendered.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerCheckoutFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerCheckoutFail = function (params) {
    return { evid: 1831, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamAddMembersToGroupClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} current_members_count - How many people currently in goup
* @property {GUID} group_id - group id
* @property {string} group_name - group name
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Add members to group click. Evid: 1207.
 * Event description: Click on the button "Add members to Group" (blue button or from empty group state).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * current_members_count - Type: numeric. Desc: How many people currently in goup
 *
 * group_id - Type: guid. Desc: group id
 *
 * group_name - Type: string. Desc: group name
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamAddMembersToGroupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamAddMembersToGroupClick = function (params) {
    return { evid: 1207, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumBlocksCreditIncentiveViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the blocked feature
* @property {boolean} is_eligible - Is the user eligible to buy a premium plan
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Blocks - Credit Incentive View. Evid: 1853.
 * Event description: An user views a call center credit incentive.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the blocked feature
 *
 * is_eligible - Type: bool. Desc: Is the user eligible to buy a premium plan
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumBlocksCreditIncentiveViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumBlocksCreditIncentiveView = function (params) {
    return { evid: 1853, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingPageLoadAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing -  Page Load Attempt. Evid: 1456.
 * Event description: There was an attempt to upload the Billing page..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingPageLoadAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingPageLoadAttempt = function (params) {
    return { evid: 1456, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerHoverOnPackageParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Hover on Package. Evid: 1823.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerHoverOnPackageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerHoverOnPackage = function (params) {
    return { evid: 1823, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbArticlesListSelectArticleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Articles list - Click on an article. Evid: 1110.
 * Event description: Click on an article from the screen.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbArticlesListSelectArticleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbArticlesListSelectArticle = function (params) {
    return { evid: 1110, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsRemoveLabelFromATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} label_id - label id
* @property {string} label_name - label name
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - reply id
* @property {string} source - {ticket filters (include/exclude), ticket top bar}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Remove label from a ticket. Evid: 1022.
 * Event description: Click a label in order to remove it from the ticket. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * label_id - Type: guid. Desc: label id
 *
 * label_name - Type: string. Desc: label name
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: reply id
 *
 * source - Type: string. Desc: {ticket filters (include/exclude), ticket top bar}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsRemoveLabelFromATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsRemoveLabelFromATicket = function (params) {
    return { evid: 1022, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsCheckUncheckTheReplyAndGoToTicketsListCheckboxParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - answers anonymous id
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
* @property {GUID} reply_id - the reply id of the submitted reply
* @property {string} reply_type - {team note/reply}
* @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - answers uuid
**/
/**
 * Name: App (Tickets) - Check\Uncheck the Reply and Go To Tickets List Checkbox. Evid: 112.
 * Event description: Agent has checked or unchecked the Reply and Go To Tickets List checkbox inside a ticket page in Answers App..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: answers anonymous id
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_and_go_to_tickets_list - Type: bool. Desc: true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 *
 * reply_id - Type: guid. Desc: the reply id of the submitted reply
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * resolution - Type: string. Desc: what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid. Desc: answers uuid
 * @param {appTicketsCheckUncheckTheReplyAndGoToTicketsListCheckboxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsCheckUncheckTheReplyAndGoToTicketsListCheckbox = function (params) {
    return { evid: 112, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamAddNewGroupMemberParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} group_id - group id
* @property {string} group_name - group name
* @property {string} lang - answers lang
* @property {string} member_name - member name
* @property {GUID} member_uuid - member uuid
* @property {string} permission_level - User's permission level
* @property {string} source - {Edit group/New group}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Add new group member. Evid: 1206.
 * Event description: Selecting a group member after clicking the "+ New Team member" button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * group_id - Type: guid. Desc: group id
 *
 * group_name - Type: string. Desc: group name
 *
 * lang - Type: string. Desc: answers lang
 *
 * member_name - Type: string. Desc: member name
 *
 * member_uuid - Type: guid. Desc: member uuid
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Edit group/New group}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamAddNewGroupMemberParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamAddNewGroupMember = function (params) {
    return { evid: 1206, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingPaymentMethodModalUseADifferentCardClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {boolean} is_checked - True if checkbox is checked, False if it is un-checked
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing - Payment Method Modal - Use A Different Card Click. Evid: 1464.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * is_checked - Type: bool. Desc: True if checkbox is checked, False if it is un-checked
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingPaymentMethodModalUseADifferentCardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingPaymentMethodModalUseADifferentCardClick = function (params) {
    return { evid: 1464, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsSavedReplyAddedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} content - saved reply's title
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - saved reply id
* @property {string} reply_type - {team note/reply}
* @property {string} results_option - {shared, personal}
* @property {string} shortcut - name of hashtag that is defined for this saved reply
* @property {string} source - Saved reply added either from the icon or by a hashtag
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Saved Reply Added. Evid: 1018.
 * Event description: click "add to reply" after selecting the reply content.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * content - Type: string. Desc: saved reply's title
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: saved reply id
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * results_option - Type: string. Desc: {shared, personal}
 *
 * shortcut - Type: string. Desc: name of hashtag that is defined for this saved reply
 *
 * source - Type: string. Desc: Saved reply added either from the icon or by a hashtag
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsSavedReplyAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsSavedReplyAdded = function (params) {
    return { evid: 1018, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsLabelAddedToTicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {boolean} is_new_label - was the label just created?
* @property {GUID} label_id - label id
* @property {string} label_name - label name
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - reply id
* @property {string} source - {ticket filters (include/exclude), ticket top bar}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Label added to ticket. Evid: 1021.
 * Event description: Click the + button in order to add a label. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * is_new_label - Type: bool. Desc: was the label just created?
 *
 * label_id - Type: guid. Desc: label id
 *
 * label_name - Type: string. Desc: label name
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: reply id
 *
 * source - Type: string. Desc: {ticket filters (include/exclude), ticket top bar}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsLabelAddedToTicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsLabelAddedToTicket = function (params) {
    return { evid: 1021, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsClickOnCheckoutParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} credits_amount - Selected amount of credits
* @property {string} current_balance - Current CCC balance
* @property {string} origin - CCC modal origin
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Click on Checkout. Evid: 1866.
 * Event description: User attempts to proceed to the call center credits checkout.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * credits_amount - Type: string. Desc: Selected amount of credits
 *
 * current_balance - Type: string. Desc: Current CCC balance
 *
 * origin - Type: string. Desc: CCC modal origin
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsClickOnCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsClickOnCheckout = function (params) {
    return { evid: 1866, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsCreditPurchaseSuccessLbParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Credit Purchase Success LB. Evid: 1867.
 * Event description: Call center credits purchase success lightbox appears.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsCreditPurchaseSuccessLbParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsCreditPurchaseSuccessLb = function (params) {
    return { evid: 1867, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOneInboxTicketPagePageLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} answers_role_id - Answers Role ID
* @property {GUID} client_id - null
* @property {boolean} is_add_signature - True or False - according to reply box settings
* @property {boolean} is_send_and_assign_to_me - True or False - according to reply box settings
* @property {boolean} is_set_and_end_action - True or False - according to reply box settings
* @property {boolean} is_show_reply_suggestions - True or False - according to reply box settings
* @property {string} lang - Answers language
* @property {string} pixel_ratio - Device Pixel Ratio
* @property {number} screen_height - View Port height
* @property {number} screen_resolution_height - Screen resolution height
* @property {number} screen_resolution_width - Screen resolution width
* @property {number} screen_width - View Port width
* @property {GUID} tenant_id - Tenant ID
* @property {string} ticket_page_width - Ticket page width
* @property {GUID} user_id - Answers user ID of the member loading the page
**/
/**
 * Name: App (One Inbox) - Ticket Page - Page Load Success. Evid: 1028.
 * Event description: This Event is triggered every time the Ticket page is Loaded Successfully in One Inbox.

 * answers_brand_id - Type: guid.
 *
 * answers_role_id - Type: guid. Desc: Answers Role ID
 *
 * client_id - Type: guid.
 *
 * is_add_signature - Type: bool. Desc: True or False - according to reply box settings
 *
 * is_send_and_assign_to_me - Type: bool. Desc: True or False - according to reply box settings
 *
 * is_set_and_end_action - Type: bool. Desc: True or False - according to reply box settings
 *
 * is_show_reply_suggestions - Type: bool. Desc: True or False - according to reply box settings
 *
 * lang - Type: string. Desc: Answers language
 *
 * pixel_ratio - Type: string. Desc: Device Pixel Ratio
 *
 * screen_height - Type: numeric. Desc: View Port height
 *
 * screen_resolution_height - Type: numeric. Desc: Screen resolution height
 *
 * screen_resolution_width - Type: numeric. Desc: Screen resolution width
 *
 * screen_width - Type: numeric. Desc: View Port width
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_page_width - Type: string. Desc: Ticket page width
 *
 * user_id - Type: guid. Desc: Answers user ID of the member loading the page
 * @param {appOneInboxTicketPagePageLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOneInboxTicketPagePageLoadSuccess = function (params) {
    return { evid: 1028, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingRequestDemoWidgetOpenTheWidgetParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - null
**/
/**
 * Name: Marketing  - "Request Demo" Widget - Open the Widget. Evid: 118.
 * Event description: The user open the 'Request Demo' widget..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid.
 * @param {marketingRequestDemoWidgetOpenTheWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingRequestDemoWidgetOpenTheWidget = function (params) {
    return { evid: 118, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsEmojiAddedToReplyParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} emoji_type - emoji type {smiley, joy...}
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - saved reply id
* @property {string} source - {team note/reply/create ticket}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Emoji added to reply. Evid: 1017.
 * Event description: Select and click on the emoji itself. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * emoji_type - Type: string. Desc: emoji type {smiley, joy...}
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: saved reply id
 *
 * source - Type: string. Desc: {team note/reply/create ticket}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsEmojiAddedToReplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsEmojiAddedToReply = function (params) {
    return { evid: 1017, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingUpdatePaymentMethodSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing -  Update Payment Method Success. Evid: 1461.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingUpdatePaymentMethodSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingUpdatePaymentMethodSuccess = function (params) {
    return { evid: 1461, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing - Update Payment Method Modal - Preview Render Fail. Evid: 1463.
 * Event description: Update payment method modal preview fails to render.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail = function (params) {
    return { evid: 1463, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticlePublishParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - {article page/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Click "Publish" button. Evid: 1104.
 * Event description: Click "Publish" button.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article page/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticlePublishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticlePublish = function (params) {
    return { evid: 1104, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbCategoriesAddCategoryCompleteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} category_id - category_id
* @property {string} category_name - User's entered value for category
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - If category - null, if subcategory - category's id
* @property {string} permission_level - User's permission level
* @property {string} source - {side bar/main screen}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Categories - Create category/subcategory click. Evid: 1112.
 * Event description: Create the category after inserting the name.

 * answers_brand_id - Type: guid.
 *
 * category_id - Type: guid. Desc: category_id
 *
 * category_name - Type: string. Desc: User's entered value for category
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: If category - null, if subcategory - category's id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {side bar/main screen}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbCategoriesAddCategoryCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbCategoriesAddCategoryComplete = function (params) {
    return { evid: 1112, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOnboardingGeneralOnboardingEventParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} params - Parameters
* @property {GUID} tenant_id - Answers Account ID
* @property {string} type - Type of event
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (Onboarding) - General "Guide" Event. Evid: 901.
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Guide" screen.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * params - Type: string. Desc: Parameters
 *
 * tenant_id - Type: guid. Desc: Answers Account ID
 *
 * type - Type: string. Desc: Type of event
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appOnboardingGeneralOnboardingEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOnboardingGeneralOnboardingEvent = function (params) {
    return { evid: 901, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSubmitTicketCancelParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - null if form_source is = 1
* @property {GUID} client_id - null
* @property {string} description - Ticket content
* @property {string} form_source - {Contact , article...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
* @property {boolean} is_attached - if there is an attachment
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} subject - Ticket subject
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: Public - "Submit a Ticket" - Cancel. Evid: 2520.
 * Event description: Cancel the ticket submission.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: null if form_source is = 1
 *
 * client_id - Type: guid.
 *
 * description - Type: string. Desc: Ticket content
 *
 * form_source - Type: string. Desc: {Contact , article...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 *
 * is_attached - Type: bool. Desc: if there is an attachment
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * subject - Type: string. Desc: Ticket subject
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 * @param {publicSubmitTicketCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSubmitTicketCancel = function (params) {
    return { evid: 2520, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerLoadStartedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Load Started. Evid: 1821.
 * Event description: User opens the Package Picker and it starts to load.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerLoadStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerLoadStarted = function (params) {
    return { evid: 1821, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicUserArticleEngagementPingParams
* @property {string} activity_type - The activity actions which the user performed (array)
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - article_id
* @property {string} article_name - article_name
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} ticket_id - The ticket id that the article was recommended for
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: Public - User - Article engagement ping. Evid: 2533.
 * Event description: When a user visits an article page he will get a "ping" every 15 seconds if he made one or more activity actions : scroll, mouse move and click within those 15 secs. The activity doesn’t have to be continuous, whenever the user shows activity he'll get a ping.
when the page view originated in email article recommendation, the ticket id recommended for will be provided..

 * activity_type - Type: string. Desc: The activity actions which the user performed (array)
 *
 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: article_id
 *
 * article_name - Type: string. Desc: article_name
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * ticket_id - Type: guid. Desc: The ticket id that the article was recommended for
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {publicUserArticleEngagementPingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicUserArticleEngagementPing = function (params) {
    return { evid: 2533, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsAddFieldToFormParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {string} source - {Widget contact form, Help center contact form}
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Add field to form. Evid: 1402.
 * Event description: Click "+ Add field".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Widget contact form, Help center contact form}
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {appSettingsTicketSettingsCustomFieldsAddFieldToFormParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsAddFieldToForm = function (params) {
    return { evid: 1402, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicAccessibilityUserActivityInArticlesParams
* @property {GUID} answers_brand_id - null
* @property {string} category - video,expand,link
* @property {GUID} client_id - The client id of the user who have an activity in the article.
* @property {GUID} user_id - The user of the user who have an activity in the article.
**/
/**
 * Name: Public - Accessibility - user activity in articles. Evid: 2540.
 * Event description: Watching video, expand collapsible and clicking on external links in accessibility articles by article_id..

 * answers_brand_id - Type: guid.
 *
 * category - Type: string. Desc: video,expand,link
 *
 * client_id - Type: guid. Desc: The client id of the user who have an activity in the article.
 *
 * user_id - Type: guid. Desc: The user of the user who have an activity in the article.
 * @param {publicAccessibilityUserActivityInArticlesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicAccessibilityUserActivityInArticles = function (params) {
    return { evid: 2540, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsAssignATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} operator - who made the assignment { User or Macro }
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id of the ticket being assigned
* @property {GUID} to_entity_id - id of the entity which the ticket is assigned to{ Group ID, User ID}
* @property {string} to_entity_name - name of the entity which the ticket is assigned to{ Group name, for user it will be null} for real time use. ***in order to use history please use the groups table
* @property {string} to_entity_type - Type of the entity which the ticket is assigned to {Group, Agent}
* @property {GUID} user_id - id of the user who assigning the ticket
**/
/**
 * Name: App (Tickets / One Inbox) - Assign a ticket. Evid: 1025.
 * Event description: Assign a ticket to a Group or to an Agent. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * operator - Type: string. Desc: who made the assignment { User or Macro }
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id of the ticket being assigned
 *
 * to_entity_id - Type: guid. Desc: id of the entity which the ticket is assigned to{ Group ID, User ID}
 *
 * to_entity_name - Type: string. Desc: name of the entity which the ticket is assigned to{ Group name, for user it will be null} for real time use. ***in order to use history please use the groups table
 *
 * to_entity_type - Type: string. Desc: Type of the entity which the ticket is assigned to {Group, Agent}
 *
 * user_id - Type: guid. Desc: id of the user who assigning the ticket
 * @param {appTicketsAssignATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsAssignATicket = function (params) {
    return { evid: 1025, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetSuggestedArticlesResolvedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - selected article id
* @property {string} article_name - selected article name
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_name - where the widget is opened from (source page name)
* @property {string} parent_url - parent_url
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: Public (Widget) - Suggested articles - issue resolved. Evid: 2240.
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "Yes! my issues was resolved"..

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: selected article id
 *
 * article_name - Type: string. Desc: selected article name
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_name - Type: string. Desc: where the widget is opened from (source page name)
 *
 * parent_url - Type: string. Desc: parent_url
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {publicWidgetSuggestedArticlesResolvedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetSuggestedArticlesResolved = function (params) {
    return { evid: 2240, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleDeleteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - {article page/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Delete an article click. Evid: 1102.
 * Event description: Click "Delete" from the top bar.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article page/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleDeleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleDelete = function (params) {
    return { evid: 1102, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appInsightsAdvancedReportsWasabiTileLoadStartParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} dashboard_filters - Applied filters on that dashboard run
* @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
* @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
* @property {string} dashboard_title - Looker Dashboard Title
* @property {string} looker_dashboard_id - Looker Dashboard ID
* @property {GUID} tenant_id - Answers Tenant ID
* @property {string} tile_listen - The global dashboard filters this tile is listening for
* @property {string} tile_title - The tile title, as shown at the top of the tile
* @property {GUID} user_id - Performing User ID
**/
/**
 * Name: App (Insights) - Advanced Reports (Wasabi) - Tile Load Start. Evid: 1322.
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * dashboard_filters - Type: string. Desc: Applied filters on that dashboard run
 *
 * dashboard_load_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 *
 * dashboard_refresh_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 *
 * dashboard_title - Type: string. Desc: Looker Dashboard Title
 *
 * looker_dashboard_id - Type: string. Desc: Looker Dashboard ID
 *
 * tenant_id - Type: guid. Desc: Answers Tenant ID
 *
 * tile_listen - Type: string. Desc: The global dashboard filters this tile is listening for
 *
 * tile_title - Type: string. Desc: The tile title, as shown at the top of the tile
 *
 * user_id - Type: guid. Desc: Performing User ID
 * @param {appInsightsAdvancedReportsWasabiTileLoadStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appInsightsAdvancedReportsWasabiTileLoadStart = function (params) {
    return { evid: 1322, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSecondStepContactUsClickOnLinkParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step user click
* @property {string} origin - upgrade origin component
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Second step - Contact us click on link. Evid: 1820.
 * Event description: Answers PP - Second step - Contact us user click on the contact link - vip@wixanswers.com mail after choosing  maximum num of agents (101+ agents).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step user click
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerSecondStepContactUsClickOnLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSecondStepContactUsClickOnLink = function (params) {
    return { evid: 1820, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} tenantsPublicHelpCenterPageViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
* @property {GUID} tenant_id - tenant of the performing user
* @property {GUID} user_id - null
**/
/**
 * Name: Tenants - Public help center page view. Evid: 2000.
 * Event description: click any of the menu items in Answers app.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * page_type - Type: string. Desc: the type of the viewed page (for ex. home page, article, ticket..)
 *
 * tenant_id - Type: guid. Desc: tenant of the performing user
 *
 * user_id - Type: guid.
 * @param {tenantsPublicHelpCenterPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tenantsPublicHelpCenterPageView = function (params) {
    return { evid: 2000, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticlePublishConfirmParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - {article page/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - "Publish my article now" click. Evid: 1105.
 * Event description: Click "Publish my article now" after being asked:
"Ready to publish your article?".

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article page/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticlePublishConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticlePublishConfirm = function (params) {
    return { evid: 1105, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicPageViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
* @property {string} parent_url - parent_url (widget)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - examples: {widget_123, yotpo_help_center1...}
* @property {string} source_type - {help center/widget}
* @property {string} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Page view. Evid: 2001.
 * Event description: page view (similar to evid 531 in src 4).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * page_type - Type: string. Desc: the type of the viewed page (for ex. home page, article, ticket..)
 *
 * parent_url - Type: string. Desc: parent_url (widget)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: examples: {widget_123, yotpo_help_center1...}
 *
 * source_type - Type: string. Desc: {help center/widget}
 *
 * tenant_id - Type: string. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicPageView = function (params) {
    return { evid: 2001, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerCheckoutSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {number} tts - Time since load started in ms
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Checkout Success. Evid: 1830.
 * Event description: User succeeds to checkout - Zuora iframe is rendered.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * tts - Type: numeric. Desc: Time since load started in ms
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerCheckoutSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerCheckoutSuccess = function (params) {
    return { evid: 1830, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleDeleteConfirmParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - {article page/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Confirm Delete click. Evid: 1103.
 * Event description: Click "Delete" after "Are you sure?" massage.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article page/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleDeleteConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleDeleteConfirm = function (params) {
    return { evid: 1103, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerVatValueChangeParams
* @property {GUID} answers_brand_id - null
* @property {string} billing_country - Billing country
* @property {GUID} client_id - null
* @property {number} current_vat - Current VAT value
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} previous_vat - Previous VAT value
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - VAT Value Change. Evid: 1838.
 * Event description: VAT value changes during purchase..

 * answers_brand_id - Type: guid.
 *
 * billing_country - Type: string. Desc: Billing country
 *
 * client_id - Type: guid.
 *
 * current_vat - Type: numeric. Desc: Current VAT value
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * previous_vat - Type: numeric. Desc: Previous VAT value
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerVatValueChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerVatValueChange = function (params) {
    return { evid: 1838, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsModalCtaClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} current_balance - Current CCC balance
* @property {boolean} is_premium - Is the tenant Premium or Free
* @property {string} origin - CCC modal origin
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Modal CTA click. Evid: 1863.
 * Event description: User clicked on the Call Center Credits (CCC) modal CTA (to the premium plans PP or the credits PP).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * current_balance - Type: string. Desc: Current CCC balance
 *
 * is_premium - Type: bool. Desc: Is the tenant Premium or Free
 *
 * origin - Type: string. Desc: CCC modal origin
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsModalCtaClick = function (params) {
    return { evid: 1863, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSearchParams
* @property {GUID} answers_brand_id - answers brand id
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} result_article_id_1 - result_article_id_1
* @property {GUID} result_article_id_2 - result_article_id_2
* @property {GUID} result_article_id_3 - result_article_id_3
* @property {number} results_count - number of search results
* @property {string} search_term - search_term
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - search. Evid: 2005.
 * Event description: asking a question (similar to evid 520 in src 4).

 * answers_brand_id - Type: guid. Desc: answers brand id
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * result_article_id_1 - Type: guid. Desc: result_article_id_1
 *
 * result_article_id_2 - Type: guid. Desc: result_article_id_2
 *
 * result_article_id_3 - Type: guid. Desc: result_article_id_3
 *
 * results_count - Type: numeric. Desc: number of search results
 *
 * search_term - Type: string. Desc: search_term
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: string. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSearch = function (params) {
    return { evid: 2005, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSubmitTicketSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - null if form_source is = 1
* @property {GUID} client_id - client_id
* @property {string} description - Ticket content
* @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
* @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
* @property {boolean} is_attached - if there is an attachment
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} subject - Ticket subject
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} ticket_id - ticket_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: Public - "Submit Ticket" - success. Evid: 2512.
 * Event description: Ticket submission success.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: null if form_source is = 1
 *
 * client_id - Type: guid. Desc: client_id
 *
 * description - Type: string. Desc: Ticket content
 *
 * form_source - Type: string. Desc: {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 *
 * is_after_suggestion - Type: bool. Desc: rather the user already clicked on a features article and clicked "No, I want to report my issue"
 *
 * is_attached - Type: bool. Desc: if there is an attachment
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * subject - Type: string. Desc: Ticket subject
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {publicSubmitTicketSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSubmitTicketSuccess = function (params) {
    return { evid: 2512, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleUnpublishParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - {article page/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Unpublish article. Evid: 1106.
 * Event description: Click "Unpublish article" from the top bar.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article page/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleUnpublishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleUnpublish = function (params) {
    return { evid: 1106, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingPageViewOnEditorMarketingPageParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_name - page name
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - user_id
**/
/**
 * Name: Marketing  - Page View on Editor Marketing page. Evid: 126.
 * Event description: The user view an Answers page in editor marketing page..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_name - Type: string. Desc: page name
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid. Desc: user_id
 * @param {marketingPageViewOnEditorMarketingPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingPageViewOnEditorMarketingPage = function (params) {
    return { evid: 126, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetWidgetLauncherLoadedClientParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} locale - Answers language
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
**/
/**
 * Name: Public (Widget) - Widget Launcher Loaded (Client). Evid: 2014.
 * Event description: The event is trigger when a launcher is loaded.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * locale - Type: string. Desc: Answers language
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 * @param {publicWidgetWidgetLauncherLoadedClientParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetWidgetLauncherLoadedClient = function (params) {
    return { evid: 2014, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicDidThisArticleHelpBannerLoadedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - article_id
* @property {string} article_name - article_name
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} ticket_id - The ticket id that the article was recommended for
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: Public - "Did this article help?" banner loaded. Evid: 2531.
 * Event description: The event is triggered when a "Did this article help?" banner is loaded while a user is viewing an article. (currently the only flow that should lead to this, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation)).

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: article_id
 *
 * article_name - Type: string. Desc: article_name
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * ticket_id - Type: guid. Desc: The ticket id that the article was recommended for
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {publicDidThisArticleHelpBannerLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicDidThisArticleHelpBannerLoaded = function (params) {
    return { evid: 2531, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSelectTeamSizeParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Select Team Size. Evid: 1825.
 * Event description: User selects team size (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1)).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerSelectTeamSizeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSelectTeamSize = function (params) {
    return { evid: 1825, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingRequestDemoWidgetWidgetLoadedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - null
**/
/**
 * Name: Marketing  - "Request Demo" Widget - Widget Loaded. Evid: 117.
 * Event description: The widget is loaded and the user can see the 'Request Demo' widget..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid.
 * @param {marketingRequestDemoWidgetWidgetLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingRequestDemoWidgetWidgetLoaded = function (params) {
    return { evid: 117, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSelectCategoryOrSubcategoryParams
* @property {GUID} answers_brand_id - null
* @property {GUID} category_id - category id
* @property {string} category_name - category name
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} source_id - source_id
* @property {string} source_name -
* @property {string} source_type - source_type
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: Public - Click on a Category or Subcategory. Evid: 2010.
 * Event description: Clicking on a category or a subcategory from the main screen (similar to event 519 in source 4).

 * answers_brand_id - Type: guid.
 *
 * category_id - Type: guid. Desc: category id
 *
 * category_name - Type: string. Desc: category name
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string.
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {publicSelectCategoryOrSubcategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSelectCategoryOrSubcategory = function (params) {
    return { evid: 2010, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbFeaturedArticlesAddAnArticleClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Featured articles - "Add an article" click. Evid: 1115.
 * Event description: "Add an article" button click.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbFeaturedArticlesAddAnArticleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbFeaturedArticlesAddAnArticleClick = function (params) {
    return { evid: 1115, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLogInSuccessUserLoginParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers uuid
* @property {boolean} is_agent - is account agent
* @property {string} login_type - wix/ google / facebook/ email
* @property {Url} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {string} subdomain - answers subdomian
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - answers ID
**/
/**
 * Name: Marketing (Log In) - Success User Login. Evid: 115.
 * Event description: User succeeds to sign in with mail or another login type on the second personal login step, after identifying his answers domain on the first step..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers uuid
 *
 * is_agent - Type: bool. Desc: is account agent
 *
 * login_type - Type: string. Desc: wix/ google / facebook/ email
 *
 * page_url - Type: url. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * subdomain - Type: string. Desc: answers subdomian
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: answers ID
 * @param {marketingLogInSuccessUserLoginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLogInSuccessUserLogin = function (params) {
    return { evid: 115, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOnboardingGeneralQuestionsEventParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} params - Parameters
* @property {GUID} tenant_id - Answers Account ID
* @property {string} type - Type of event
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (Onboarding) - General "Questions" Event. Evid: 902.
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Questions" screen.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * params - Type: string. Desc: Parameters
 *
 * tenant_id - Type: guid. Desc: Answers Account ID
 *
 * type - Type: string. Desc: Type of event
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appOnboardingGeneralQuestionsEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOnboardingGeneralQuestionsEvent = function (params) {
    return { evid: 902, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingRequestDemoFormSubmitRequestDemoParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - user id
**/
/**
 * Name: Marketing  - "Request Demo" Form - Submit Request Demo. Evid: 122.
 * Event description: The user fill all the inputs and submit the request to schedule a demo..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid. Desc: user id
 * @param {marketingRequestDemoFormSubmitRequestDemoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingRequestDemoFormSubmitRequestDemo = function (params) {
    return { evid: 122, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxChangeTicketStatusParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {number} status_id - status id
* @property {string} status_name - status name {pending, closed...}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Change ticket status. Evid: 1008.
 * Event description: Ticket top bar - Status changed (click on button after selecting a new status). event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * status_id - Type: numeric. Desc: status id
 *
 * status_name - Type: string. Desc: status name {pending, closed...}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxChangeTicketStatusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxChangeTicketStatus = function (params) {
    return { evid: 1008, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsAgentClickRolesInTheSettingsMenuParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID
**/
/**
 * Name: App (Settings) - Agent click "Roles" in the settings menu. Evid: 1453.
 * Event description: An agent click "roles" in the settings menu of Answers App.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID
 * @param {appSettingsAgentClickRolesInTheSettingsMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsAgentClickRolesInTheSettingsMenu = function (params) {
    return { evid: 1453, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsAddALabelClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Add a label click. Evid: 1020.
 * Event description: Click the + button from inside a ticket in order to add a label.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsAddALabelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsAddALabelClick = function (params) {
    return { evid: 1020, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbChangeCategorySIconParams
* @property {string} action - {Remove,Upload,Stock}
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - uuid
**/
/**
 * Name: App (KB) - Change Category's icon. Evid: 1124.
 * Event description: Change the category's icon for display.

 * action - Type: string. Desc: {Remove,Upload,Stock}
 *
 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: uuid
 * @param {appKbChangeCategorySIconParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbChangeCategorySIcon = function (params) {
    return { evid: 1124, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingCampaignPageSubmitCampaignFormParams
* @property {GUID} answers_brand_id - null
* @property {GUID} campaign_id - campaign_id
* @property {string} campaign_name - campaign_name
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - user_id
**/
/**
 * Name: Marketing  - Campaign page - Submit Campaign Form. Evid: 125.
 * Event description: The user submit the campaign form and send his details..

 * answers_brand_id - Type: guid.
 *
 * campaign_id - Type: guid. Desc: campaign_id
 *
 * campaign_name - Type: string. Desc: campaign_name
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid. Desc: user_id
 * @param {marketingCampaignPageSubmitCampaignFormParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingCampaignPageSubmitCampaignForm = function (params) {
    return { evid: 125, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerPurchaseModalLinkClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {Url} link_name - Link clicked
* @property {string} modal_name - Modal name (success / failure)
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Purchase Modal Link Click. Evid: 1835.
 * Event description: User clicks link from modal after purchase success or fail.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * link_name - Type: url. Desc: Link clicked
 *
 * modal_name - Type: string. Desc: Modal name (success / failure)
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerPurchaseModalLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerPurchaseModalLinkClick = function (params) {
    return { evid: 1835, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOneInboxTicketListPageLoadSuccessParams
* @property {string} active_ticket_list_height - If Layout is Split Pane  - Active ticket list height
* @property {string} active_ticket_list_sort - If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
* @property {GUID} answers_brand_id - null
* @property {GUID} answers_role_id - Answers Role ID
* @property {GUID} client_id - null
* @property {number} first_message_position - If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
* @property {string} inactive_ticket_list_height - If Layout is Split Pane - Inactive ticket list height
* @property {string} inactive_ticket_list_sort - If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
* @property {boolean} is_active_ticket_list_collapsed - True, False or blank (if If layout is Split Pane)
* @property {boolean} is_my_activity - True - if "only my activity" toggle is enabled, False - if not
* @property {boolean} is_views_pinned - Is view menu pinned (True or False)
* @property {string} lang - answers language
* @property {string} layout_type - Ticket List layout type (Split Pane, List or Table)
* @property {string} pixel_ratio - Device Pixel Ratio
* @property {number} screen_height - View Port height
* @property {number} screen_resolution_height - Screen resolution height
* @property {number} screen_resolution_width - Screen resolution width
* @property {number} screen_width - View Port width
* @property {string} status_filter - For all layouts (if Split pane - Inactive list) - What status filter is being applied (all, open, solved etc.)
* @property {string} table_column_positions - If Layout is Table - A Json with all the columns appear in the table layout and their positions, if layout is not table - NULL
* @property {string} table_or_list_sort - If Layout is Table or List - The Type of sort (newest reply, highest priority etc.)
* @property {GUID} tenant_id - Tenant ID
* @property {string} ticket_list_width - If Layout is Split Pane  - Active and Inactive ticket list width
* @property {string} ticket_page_area_width - If Layout is Split Pane -  The ticket page area width
* @property {number} ticket_subject_position - If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
* @property {string} ticket_view_filters - A json with all the filters being applied as part of the ticket view
* @property {GUID} user_id - Answers user ID of the member loading the page
* @property {GUID} view_id - The Ticket List view ID
**/
/**
 * Name: App (One Inbox) - Ticket List - Page Load Success. Evid: 1027.
 * Event description: This Event is triggered every time the Ticket List Page is Loaded Successfully in One Inbox.
(please remember to create position columns for all existed columns of table layout and let me know their names afterwards and I will add them to the event).

 * active_ticket_list_height - Type: string. Desc: If Layout is Split Pane  - Active ticket list height
 *
 * active_ticket_list_sort - Type: string. Desc: If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
 *
 * answers_brand_id - Type: guid.
 *
 * answers_role_id - Type: guid. Desc: Answers Role ID
 *
 * client_id - Type: guid.
 *
 * first_message_position - Type: numeric. Desc: If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
 *
 * inactive_ticket_list_height - Type: string. Desc: If Layout is Split Pane - Inactive ticket list height
 *
 * inactive_ticket_list_sort - Type: string. Desc: If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
 *
 * is_active_ticket_list_collapsed - Type: bool. Desc: True, False or blank (if If layout is Split Pane)
 *
 * is_my_activity - Type: bool. Desc: True - if "only my activity" toggle is enabled, False - if not
 *
 * is_views_pinned - Type: bool. Desc: Is view menu pinned (True or False)
 *
 * lang - Type: string. Desc: answers language
 *
 * layout_type - Type: string. Desc: Ticket List layout type (Split Pane, List or Table)
 *
 * pixel_ratio - Type: string. Desc: Device Pixel Ratio
 *
 * screen_height - Type: numeric. Desc: View Port height
 *
 * screen_resolution_height - Type: numeric. Desc: Screen resolution height
 *
 * screen_resolution_width - Type: numeric. Desc: Screen resolution width
 *
 * screen_width - Type: numeric. Desc: View Port width
 *
 * status_filter - Type: string. Desc: For all layouts (if Split pane - Inactive list) - What status filter is being applied (all, open, solved etc.)
 *
 * table_column_positions - Type: string. Desc: If Layout is Table - A Json with all the columns appear in the table layout and their positions, if layout is not table - NULL
 *
 * table_or_list_sort - Type: string. Desc: If Layout is Table or List - The Type of sort (newest reply, highest priority etc.)
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_list_width - Type: string. Desc: If Layout is Split Pane  - Active and Inactive ticket list width
 *
 * ticket_page_area_width - Type: string. Desc: If Layout is Split Pane -  The ticket page area width
 *
 * ticket_subject_position - Type: numeric. Desc: If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
 *
 * ticket_view_filters - Type: string. Desc: A json with all the filters being applied as part of the ticket view
 *
 * user_id - Type: guid. Desc: Answers user ID of the member loading the page
 *
 * view_id - Type: guid. Desc: The Ticket List view ID
 * @param {appOneInboxTicketListPageLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOneInboxTicketListPageLoadSuccess = function (params) {
    return { evid: 1027, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingUpdatePaymentMethodAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing -  Update Payment Method Attempt. Evid: 1460.
 * Event description: Update Payment Method Attempt.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingUpdatePaymentMethodAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingUpdatePaymentMethodAttempt = function (params) {
    return { evid: 1460, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsCreditPurchaseFailLbParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Credit Purchase Fail LB. Evid: 1868.
 * Event description: Call center credits purchase fail lightbox appears.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsCreditPurchaseFailLbParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsCreditPurchaseFailLb = function (params) {
    return { evid: 1868, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpSignUpFailedFirstStepParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - answers client id
* @property {number} campaign_id - DEPRECATE
* @property {string} errorReason - DEPRECATE
* @property {string} error_reason - the reason for the failure
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - Answers uuid
**/
/**
 * Name: Marketing (Sign Up) - Sign Up failed - first step. Evid: 105.
 * Event description: User's first step of sign up failed.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: answers client id
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * errorReason - Type: string. Desc: DEPRECATE
 *
 * error_reason - Type: string. Desc: the reason for the failure
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 * @param {marketingSignUpSignUpFailedFirstStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpSignUpFailedFirstStep = function (params) {
    return { evid: 105, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralFtueVideoLightboxCloseParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the feature the lightbox is shown in
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (General) - FTUE Video Lightbox - Close. Evid: 1949.
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was closed by the user.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the feature the lightbox is shown in
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appGeneralFtueVideoLightboxCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralFtueVideoLightboxClose = function (params) {
    return { evid: 1949, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamAddAnotherTeamMemberParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - "Add another" team member. Evid: 1202.
 * Event description: Click on the "Add another" button to add other members.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamAddAnotherTeamMemberParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamAddAnotherTeamMember = function (params) {
    return { evid: 1202, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsDeleteFieldParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} field_name - field name
* @property {string} field_type - {text, drop-down...}
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Delete field. Evid: 1405.
 * Event description: Click "Delete field" button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: {text, drop-down...}
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 * @param {appSettingsTicketSettingsCustomFieldsDeleteFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsDeleteField = function (params) {
    return { evid: 1405, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsRolesAgentClickEditRoleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} role_id - The Role ID of the role being "clicked"
* @property {string} role_name - The Role Name of the role being "clicked"
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID
**/
/**
 * Name: App (Settings) - Roles -  Agent Click "Edit" role. Evid: 1455.
 * Event description: An agent click "Edit" in the right corner menu (3 dots) in the roles section within Answers Settings..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * role_id - Type: guid. Desc: The Role ID of the role being "clicked"
 *
 * role_name - Type: string. Desc: The Role Name of the role being "clicked"
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID
 * @param {appSettingsRolesAgentClickEditRoleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsRolesAgentClickEditRole = function (params) {
    return { evid: 1455, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicVoteForKnownIssueParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - Article ID
* @property {GUID} category_id - Category ID
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} tenant_id - Tenant ID
* @property {boolean} thumbs_up - {true, false}
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Vote for Known issue button. Evid: 2004.
 * Event description: Click the (I have this problem (bug)) (similar to evid 503 in src 4).

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: Article ID
 *
 * category_id - Type: guid. Desc: Category ID
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: string. Desc: Tenant ID
 *
 * thumbs_up - Type: bool. Desc: {true, false}
 *
 * user_id - Type: guid.
 * @param {publicVoteForKnownIssueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicVoteForKnownIssue = function (params) {
    return { evid: 2004, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamMainTabClickedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} tab_name - {Team members, Pending Invitations..}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Main tab clicked. Evid: 1200.
 * Event description: Click on a tab.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tab_name - Type: string. Desc: {Team members, Pending Invitations..}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamMainTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamMainTabClicked = function (params) {
    return { evid: 1200, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOneInboxAMemberClientEngagementParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} data - Json of Data related to the member's engagement. Examples: (1) when changing ticket priority it will show priority before and after, ticket ID etc. , (2) when clicking on a ticket it will show ticket ID
* @property {string} engaged_component - What "component" the member clicked/engaged with. Examples: Views Panel, Tickets list, Ticket Item, reply box etc.
* @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with. Examples: (1) Change Ticket Status, (2) Ticket Info, (3) Views, (4) Pin/Unpin menu etc.
* @property {string} engagement_name - The name of the Engagement
* @property {string} lang - Answers language
* @property {GUID} role_id - Answers Role ID
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (One Inbox) - A member Client Engagement. Evid: 1026.
 * Event description: A generic event for member's clicks/engagements related to One Inbox different components: Views Panel, Tickets List, Ticket Item, Ticket Header, Ticket Actions (footer), Reply Box, Info Panel, App header and Bulk Actions.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: Json of Data related to the member's engagement. Examples: (1) when changing ticket priority it will show priority before and after, ticket ID etc. , (2) when clicking on a ticket it will show ticket ID
 *
 * engaged_component - Type: string. Desc: What "component" the member clicked/engaged with. Examples: Views Panel, Tickets list, Ticket Item, reply box etc.
 *
 * engaged_sub_component - Type: string. Desc: What "sub component" the member clicked/engaged with. Examples: (1) Change Ticket Status, (2) Ticket Info, (3) Views, (4) Pin/Unpin menu etc.
 *
 * engagement_name - Type: string. Desc: The name of the Engagement
 *
 * lang - Type: string. Desc: Answers language
 *
 * role_id - Type: guid. Desc: Answers Role ID
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appOneInboxAMemberClientEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOneInboxAMemberClientEngagement = function (params) {
    return { evid: 1026, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpSignUpFailedSecondStepParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers client ID
* @property {number} campaign_id - DEPRECATE
* @property {string} error_reason - failure reason
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {string} subdomain - Answers URL
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - Answers uuid
**/
/**
 * Name: Marketing (Sign Up) - Sign Up failed -  second step. Evid: 108.
 * Event description: User attempt to submit second sign up flow - add organization and URL.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers client ID
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * error_reason - Type: string. Desc: failure reason
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * subdomain - Type: string. Desc: Answers URL
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 * @param {marketingSignUpSignUpFailedSecondStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpSignUpFailedSecondStep = function (params) {
    return { evid: 108, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetToggleModuleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_name - where the widget is opened from (source page name)
* @property {string} parent_url - parent_url
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {string} switch_to - the new state of the widget
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: Public (Widget) - Toggle Module. Evid: 2230.
 * Event description: Click on the top icon to switch between "contact" and "help".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_name - Type: string. Desc: where the widget is opened from (source page name)
 *
 * parent_url - Type: string. Desc: parent_url
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * switch_to - Type: string. Desc: the new state of the widget
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {publicWidgetToggleModuleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetToggleModule = function (params) {
    return { evid: 2230, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appInsightsAnalysisClickedParams
* @property {string} analysis_name - {Tickets open, Solved tickets, Closed tickets, response time...}
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} date_range - {costumed range, last 7 days, last 30 days...}
* @property {string} filter_channel - Channel filter value
* @property {string} filter_country - Country filter value
* @property {string} filter_lang - Language filter value
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} tab_name - current tab name {Product insights, Tickets statistics...}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Insights) - Analysis clicked. Evid: 1310.
 * Event description: Click on any of the analysis types on the dashboard.

 * analysis_name - Type: string. Desc: {Tickets open, Solved tickets, Closed tickets, response time...}
 *
 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * date_range - Type: string. Desc: {costumed range, last 7 days, last 30 days...}
 *
 * filter_channel - Type: string. Desc: Channel filter value
 *
 * filter_country - Type: string. Desc: Country filter value
 *
 * filter_lang - Type: string. Desc: Language filter value
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tab_name - Type: string. Desc: current tab name {Product insights, Tickets statistics...}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appInsightsAnalysisClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appInsightsAnalysisClicked = function (params) {
    return { evid: 1310, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appWasabiAdvancedReportsClickOn3DotsParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} reportName - report name
* @property {string} selectedValue - null
* @property {GUID} tenant_id - answers tenant_id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Wasabi) - Advanced Reports Click on 3 dots. Evid: 1330.
 * Event description: User Click on 3 dots (more option per report)
after selecting an action - View / Duplicate / Delete.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * reportName - Type: string. Desc: report name
 *
 * selectedValue - Type: string.
 *
 * tenant_id - Type: guid. Desc: answers tenant_id
 *
 * user_id - Type: guid.
 * @param {appWasabiAdvancedReportsClickOn3DotsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appWasabiAdvancedReportsClickOn3Dots = function (params) {
    return { evid: 1330, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSuggestedArticlesClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} description - Ticket content (used as search term for suggested articles)
* @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} selected_article_id - selected article id
* @property {string} selected_article_name - selected article name
* @property {GUID} source_article_id - null if form_source is = 1
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} subject - Ticket subject (used as search term for suggested articles)
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Suggested articles - click. Evid: 2530.
 * Event description: Clicking on one of the suggested articles from inside a ticket submission..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * description - Type: string. Desc: Ticket content (used as search term for suggested articles)
 *
 * form_source - Type: string. Desc: {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * selected_article_id - Type: guid. Desc: selected article id
 *
 * selected_article_name - Type: string. Desc: selected article name
 *
 * source_article_id - Type: guid. Desc: null if form_source is = 1
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * subject - Type: string. Desc: Ticket subject (used as search term for suggested articles)
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 * @param {publicSuggestedArticlesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSuggestedArticlesClick = function (params) {
    return { evid: 2530, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpSignUpSuccessSecondStepParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} campaign_id - DEPRECATE
* @property {string} locale - DEPRECATE
* @property {string} location - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {Url} page_url - URL of current page
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {string} sign_up_method - The method that was used to sign up the user (Email, Wix, Google, etc.)
* @property {string} subdomain - Answers URL
* @property {GUID} tenant_id -
* @property {GUID} user_id - null
* @property {GUID} wix_client_id - Wix client (Anonymous) ID
* @property {GUID} wix_user_id - wix user id
**/
/**
 * Name: Marketing (Sign Up) - Sign Up success - second step. Evid: 107.
 * Event description: Click on the "Log In" button to start l````````````````````````````````````````````````````````````````````````````````````````````````````````````ogin form in wixanswers.com's homepage or from sign up the first step-.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * location - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * page_url - Type: url. Desc: URL of current page
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * sign_up_method - Type: string. Desc: The method that was used to sign up the user (Email, Wix, Google, etc.)
 *
 * subdomain - Type: string. Desc: Answers URL
 *
 * tenant_id - Type: guid.
 *
 * user_id - Type: guid.
 *
 * wix_client_id - Type: guid. Desc: Wix client (Anonymous) ID
 *
 * wix_user_id - Type: guid. Desc: wix user id
 * @param {marketingSignUpSignUpSuccessSecondStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpSignUpSuccessSecondStep = function (params) {
    return { evid: 107, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxDeleteAReplyConfirmParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} content - reply's content
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - reply id
* @property {string} reply_type - {team note/reply}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Delete a reply confirm. Evid: 1013.
 * Event description: Click "OK" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * content - Type: string. Desc: reply's content
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: reply id
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxDeleteAReplyConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxDeleteAReplyConfirm = function (params) {
    return { evid: 1013, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appInsightsTabClickedFromTopBarParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} source_name - place clicked from
* @property {string} tab_name - tab name {Top issues, Tickets statistics...}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Insights) - Tab clicked from top bar. Evid: 1300.
 * Event description: Tab clicked from top bar.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source_name - Type: string. Desc: place clicked from
 *
 * tab_name - Type: string. Desc: tab name {Top issues, Tickets statistics...}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appInsightsTabClickedFromTopBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appInsightsTabClickedFromTopBar = function (params) {
    return { evid: 1300, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsFieldsAddedToFormClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} count_fields - How many fields were added
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {string} source - {Fields manager, Widget contact form, Help center contact form}
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Fields added to form click. Evid: 1403.
 * Event description: Adding selected field  - click "Add selected fields".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * count_fields - Type: string. Desc: How many fields were added
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Fields manager, Widget contact form, Help center contact form}
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {appSettingsTicketSettingsCustomFieldsFieldsAddedToFormClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsFieldsAddedToFormClick = function (params) {
    return { evid: 1403, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamCreateANewGroupClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} group_id - group id
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} group_name - group name
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Create a new group click. Evid: 1205.
 * Event description: Clicking the "Create Team" button after inserting group name.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * group_id - Type: guid. Desc: group id
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * group_name - Type: string. Desc: group name
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamCreateANewGroupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamCreateANewGroupClick = function (params) {
    return { evid: 1205, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicNoSearchResultsParams
* @property {GUID} answers_brand_id - answers brand id
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {string} search_term - search_term
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Got no answer. Evid: 2008.
 * Event description: got no answer (similar to evid 537 in src 4).

 * answers_brand_id - Type: guid. Desc: answers brand id
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * search_term - Type: string. Desc: search_term
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicNoSearchResultsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicNoSearchResults = function (params) {
    return { evid: 2008, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerUserClosedPpLightBoxParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - Answers product plan price
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - Yearly/monthly
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - User closed PP light box. Evid: 1812.
 * Event description: Answers PP - Close lightbox on any step with closing method attribute: click on X button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: Answers product plan price
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: Yearly/monthly
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerUserClosedPpLightBoxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerUserClosedPpLightBox = function (params) {
    return { evid: 1812, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumBlocksCreditIncentiveIncentiveCtaClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the blocked feature
* @property {boolean} is_eligible - Is the user eligible to buy a premium plan
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Blocks - Credit Incentive Incentive CTA Click. Evid: 1854.
 * Event description: A user clicks on a CTA in a call center credit incentive.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the blocked feature
 *
 * is_eligible - Type: bool. Desc: Is the user eligible to buy a premium plan
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumBlocksCreditIncentiveIncentiveCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumBlocksCreditIncentiveIncentiveCtaClick = function (params) {
    return { evid: 1854, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicChatbotTicketCreatedFromTheChatbotParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {GUID} session_id - null
* @property {string} tenant_id - tenant_id
* @property {GUID} ticket_id - ticket_id that user opened from the chat bot
* @property {GUID} user_id - user_id
**/
/**
 * Name: Public (Chatbot) - Ticket created from the chatbot. Evid: 2261.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * session_id - Type: guid.
 *
 * tenant_id - Type: string. Desc: tenant_id
 *
 * ticket_id - Type: guid. Desc: ticket_id that user opened from the chat bot
 *
 * user_id - Type: guid. Desc: user_id
 * @param {publicChatbotTicketCreatedFromTheChatbotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicChatbotTicketCreatedFromTheChatbot = function (params) {
    return { evid: 2261, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicChatbotStepReachedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} chatbot_step_id - step_id
* @property {string} chatbot_step_input_type - null
* @property {string} chatbot_step_name - The name the user defined in this step (can be a message / a question etc.)
* @property {string} chatbot_step_type - step_type: messages, user_input, api_call, conditions, custom_fields, etc.
* @property {GUID} client_id - client_id
* @property {GUID} session_id - null
* @property {string} tenant_id - tenant_id
* @property {string} user_device_type - the device type of the user - Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile.
* @property {GUID} user_id - user_id
* @property {GUID} widget_id - widget_id
**/
/**
 * Name: Public (chatbot) - step reached. Evid: 2270.
 * Event description: UOU reached a step in the chatbot that was built by our users.

 * answers_brand_id - Type: guid.
 *
 * chatbot_step_id - Type: guid. Desc: step_id
 *
 * chatbot_step_input_type - Type: string.
 *
 * chatbot_step_name - Type: string. Desc: The name the user defined in this step (can be a message / a question etc.)
 *
 * chatbot_step_type - Type: string. Desc: step_type: messages, user_input, api_call, conditions, custom_fields, etc.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * session_id - Type: guid.
 *
 * tenant_id - Type: string. Desc: tenant_id
 *
 * user_device_type - Type: string. Desc: the device type of the user - Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile.
 *
 * user_id - Type: guid. Desc: user_id
 *
 * widget_id - Type: guid. Desc: widget_id
 * @param {publicChatbotStepReachedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicChatbotStepReached = function (params) {
    return { evid: 2270, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLogInPreLoginRedirectFailedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} campaign_id - The filed will be deprecated
* @property {string} errorReason - The filed will be deprecated
* @property {string} error_reason - The failed reason
* @property {string} locale - Answers language
* @property {GUID} marketing_id - The filed will be deprecated
* @property {Url} page_url - current page
* @property {string} permission_level - the field will be deprecated
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - A unique guid for login flow
* @property {string} subdomain - The sub-domain entered in the form
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - null
**/
/**
 * Name: Marketing (Log In) - Pre-Login redirect failed. Evid: 111.
 * Event description: User's Pre- login - redirect tenant URL failed.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * campaign_id - Type: numeric. Desc: The filed will be deprecated
 *
 * errorReason - Type: string. Desc: The filed will be deprecated
 *
 * error_reason - Type: string. Desc: The failed reason
 *
 * locale - Type: string. Desc: Answers language
 *
 * marketing_id - Type: guid. Desc: The filed will be deprecated
 *
 * page_url - Type: url. Desc: current page
 *
 * permission_level - Type: string. Desc: the field will be deprecated
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: A unique guid for login flow
 *
 * subdomain - Type: string. Desc: The sub-domain entered in the form
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid.
 * @param {marketingLogInPreLoginRedirectFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLogInPreLoginRedirectFailed = function (params) {
    return { evid: 111, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicPageViewTicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client id
* @property {string} locale - Answers language
* @property {string} parent_url - parent_url (widget)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} ticket_id - ticket_id
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Page view (ticket). Evid: 1998.
 * Event description: Ticket - page view.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client id
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: parent_url (widget)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_id - Type: guid. Desc: ticket_id
 *
 * user_id - Type: guid.
 * @param {publicPageViewTicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicPageViewTicket = function (params) {
    return { evid: 1998, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOneInboxEndActiveSessionParams
* @property {GUID} answers_brand_id - Answers Brand id
* @property {GUID} answers_role_id - Answers Role ID
* @property {string} assigned_entity - Second phase - Is the ticket assigned to a Group or Member
* @property {GUID} assigned_entity_id - Assigned Entity ID
* @property {string} channel - The Channel of the ticket
* @property {GUID} client_id - client id
* @property {string} end_session_type - End Manually/ End Automatically
* @property {string} lang - Answers language
* @property {number} member_existed_active_sessions - The number of active sessions the member has after ending this session
* @property {GUID} session_id - hash_id of session start event
* @property {GUID} tenant_id - Tenant ID
* @property {number} ticket_existed_active_sessions - The number of active sessions the ticket has after ending this session
* @property {GUID} ticket_id - Ticket ID
* @property {number} ticket_status_type - Second phase - Ticket Status
* @property {GUID} user_id - Answers user ID of the member loading the page
**/
/**
 * Name: App (One Inbox) - End Active Session. Evid: 4905.
 * Event description: This Event is triggered every time a member is ending an active session by clicking the "End Sessions" or when their session ends automatically.

 * answers_brand_id - Type: guid. Desc: Answers Brand id
 *
 * answers_role_id - Type: guid. Desc: Answers Role ID
 *
 * assigned_entity - Type: string. Desc: Second phase - Is the ticket assigned to a Group or Member
 *
 * assigned_entity_id - Type: guid. Desc: Assigned Entity ID
 *
 * channel - Type: string. Desc: The Channel of the ticket
 *
 * client_id - Type: guid. Desc: client id
 *
 * end_session_type - Type: string. Desc: End Manually/ End Automatically
 *
 * lang - Type: string. Desc: Answers language
 *
 * member_existed_active_sessions - Type: numeric. Desc: The number of active sessions the member has after ending this session
 *
 * session_id - Type: guid. Desc: hash_id of session start event
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_existed_active_sessions - Type: numeric. Desc: The number of active sessions the ticket has after ending this session
 *
 * ticket_id - Type: guid. Desc: Ticket ID
 *
 * ticket_status_type - Type: numeric. Desc: Second phase - Ticket Status
 *
 * user_id - Type: guid. Desc: Answers user ID of the member loading the page
 * @param {appOneInboxEndActiveSessionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOneInboxEndActiveSession = function (params) {
    return { evid: 4905, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsFieldRemovedFromFormParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} field_name - field name
* @property {string} field_type - {text, drop-down...}
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {string} source - {Widget contact form, Help center contact form}
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Field removed from form. Evid: 1404.
 * Event description: Removing a field from a form - click on "Remove".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: {text, drop-down...}
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Widget contact form, Help center contact form}
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {appSettingsTicketSettingsCustomFieldsFieldRemovedFromFormParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsFieldRemovedFromForm = function (params) {
    return { evid: 1404, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxDeleteATicketClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {number} status_id - status id
* @property {string} status_name - status name
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Delete a ticket click. Evid: 1009.
 * Event description: click "delete" option from the bottom bar. event is triggered from both Tickets and One Inbox modules,.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * status_id - Type: numeric. Desc: status id
 *
 * status_name - Type: string. Desc: status name
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxDeleteATicketClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxDeleteATicketClick = function (params) {
    return { evid: 1009, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxAddEmailReplySuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
* @property {GUID} reply_id - reply id
* @property {string} reply_type - {team note/reply}
* @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Add Email Reply - Success. Evid: 1011.
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_and_go_to_tickets_list - Type: bool. Desc: true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 *
 * reply_id - Type: guid. Desc: reply id
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * resolution - Type: string. Desc: what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxAddEmailReplySuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxAddEmailReplySuccess = function (params) {
    return { evid: 1011, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamRemoveTeamMemberConfirmParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} team_member_permission_level - {admin/agent}
* @property {GUID} team_member_uuid - team member uuid
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Remove team member confirm. Evid: 1213.
 * Event description: Click "Delete" button after being asked "Are you sure?".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * team_member_permission_level - Type: string. Desc: {admin/agent}
 *
 * team_member_uuid - Type: guid. Desc: team member uuid
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamRemoveTeamMemberConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamRemoveTeamMemberConfirm = function (params) {
    return { evid: 1213, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLogInPreLoginRedirectSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id -
* @property {number} campaign_id - The field will be deprtecated
* @property {string} locale - Answers language
* @property {GUID} marketing_id - The field will be deprecated
* @property {string} permission_level - The field will be deprtecated
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - A unique guid for login flow
* @property {string} subdomain - Answers tenant URL
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id -
**/
/**
 * Name: Marketing (Log In) - Pre-Login redirect success. Evid: 110.
 * Event description: User's Pre- login success - redirect tenant URL.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * campaign_id - Type: numeric. Desc: The field will be deprtecated
 *
 * locale - Type: string. Desc: Answers language
 *
 * marketing_id - Type: guid. Desc: The field will be deprecated
 *
 * permission_level - Type: string. Desc: The field will be deprtecated
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: A unique guid for login flow
 *
 * subdomain - Type: string. Desc: Answers tenant URL
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid.
 * @param {marketingLogInPreLoginRedirectSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLogInPreLoginRedirectSuccess = function (params) {
    return { evid: 110, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsDeleteFieldVerification1Params
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} field_name - field name
* @property {string} field_type - {text, drop-down...}
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Delete field (Verification 1). Evid: 1406.
 * Event description: Click "Delete" button after being asked "are you sure?".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: {text, drop-down...}
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 * @param {appSettingsTicketSettingsCustomFieldsDeleteFieldVerification1Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsDeleteFieldVerification1 = function (params) {
    return { evid: 1406, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleAssignCategoryParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} category_id - selected category id
* @property {string} category_name - selected category name
* @property {GUID} client_id - null
* @property {GUID} dest_parent_id - selected category/subcategory
* @property {string} lang - answers language
* @property {GUID} orig_parent_id - current category/subcategory of an article (null if new)
* @property {string} permission_level - User's permission level
* @property {string} source - {article/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Assign article to category/subcategory. Evid: 1107.
 * Event description: Choose a category for an article.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * category_id - Type: guid. Desc: selected category id
 *
 * category_name - Type: string. Desc: selected category name
 *
 * client_id - Type: guid.
 *
 * dest_parent_id - Type: guid. Desc: selected category/subcategory
 *
 * lang - Type: string. Desc: answers language
 *
 * orig_parent_id - Type: guid. Desc: current category/subcategory of an article (null if new)
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleAssignCategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleAssignCategory = function (params) {
    return { evid: 1107, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicPageViewCategoryParams
* @property {GUID} answers_brand_id - null
* @property {GUID} category_id - category_id
* @property {string} category_name - category_name
* @property {GUID} client_id - client id
* @property {string} locale - Answers language
* @property {string} parent_url - parent_url (widget)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {GUID} sub_category_id - sub_category_id
* @property {string} sub_category_name - sub_category_name
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Page view (category). Evid: 1999.
 * Event description: Category/subcategory - page view.

 * answers_brand_id - Type: guid.
 *
 * category_id - Type: guid. Desc: category_id
 *
 * category_name - Type: string. Desc: category_name
 *
 * client_id - Type: guid. Desc: client id
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: parent_url (widget)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * sub_category_id - Type: guid. Desc: sub_category_id
 *
 * sub_category_name - Type: string. Desc: sub_category_name
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid.
 * @param {publicPageViewCategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicPageViewCategory = function (params) {
    return { evid: 1999, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsThumbsDownASuggestedArticleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - linked article id
* @property {string} article_name - linked article name
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} order_location - article order location in search/suggestions
* @property {string} search_term - the string used for searching relevant articles is the ticket subject
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - related ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Thumbs down a suggested article. Evid: 1003.
 * Event description: Voting against a suggested article for a ticket.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: linked article id
 *
 * article_name - Type: string. Desc: linked article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * order_location - Type: string. Desc: article order location in search/suggestions
 *
 * search_term - Type: string. Desc: the string used for searching relevant articles is the ticket subject
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: related ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsThumbsDownASuggestedArticleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsThumbsDownASuggestedArticle = function (params) {
    return { evid: 1003, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralPageLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} answers_role_id - Answers Role ID
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {string} module - module
* @property {Url} page_url - page_url
* @property {string} permission_level - User's permission level
* @property {string} pixel_ratio - Device Pixel Ratio
* @property {number} screen_height - View Port height
* @property {number} screen_resolution_height - Screen resolution height
* @property {number} screen_resolution_width - Screen resolution width
* @property {number} screen_width - View Port width
* @property {string} section_key - specific section that user tried to change
* @property {GUID} tenant_id - tenant_id
* @property {GUID} ticket_id - null
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (General) - Page Load Success. Evid: 1951.
 * Event description: General event - like "page view".

 * answers_brand_id - Type: guid.
 *
 * answers_role_id - Type: guid. Desc: Answers Role ID
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * module - Type: string. Desc: module
 *
 * page_url - Type: url. Desc: page_url
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * pixel_ratio - Type: string. Desc: Device Pixel Ratio
 *
 * screen_height - Type: numeric. Desc: View Port height
 *
 * screen_resolution_height - Type: numeric. Desc: Screen resolution height
 *
 * screen_resolution_width - Type: numeric. Desc: Screen resolution width
 *
 * screen_width - Type: numeric. Desc: View Port width
 *
 * section_key - Type: string. Desc: specific section that user tried to change
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * ticket_id - Type: guid.
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appGeneralPageLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralPageLoadSuccess = function (params) {
    return { evid: 1951, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralViewMyKnowledgeBaseClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} permission_level - Users's permission level
* @property {string} source_tab - The location (source tab) of the user in the app when clicking on the item
* @property {GUID} tenant_id - tenant of the performing user
* @property {GUID} user_id - null
**/
/**
 * Name: App (General) - "View my knowledge base" click. Evid: 1900.
 * Event description: click on view my knowledge base button from the side menu.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * permission_level - Type: string. Desc: Users's permission level
 *
 * source_tab - Type: string. Desc: The location (source tab) of the user in the app when clicking on the item
 *
 * tenant_id - Type: guid. Desc: tenant of the performing user
 *
 * user_id - Type: guid.
 * @param {appGeneralViewMyKnowledgeBaseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralViewMyKnowledgeBaseClick = function (params) {
    return { evid: 1900, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsChangeFailParams
* @property {GUID} answers_brand_id - null
* @property {string} change_content - json with all the changed information
* @property {string} changeType - {delete/create/update}
* @property {GUID} client_id - client_id
* @property {string} errorReason - Reason for fail
* @property {string} lang - answers language
* @property {Url} page_url - page_url
* @property {string} section_key - specific section that user tried to change
* @property {string} source_name - hc-1 / hc-2
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (Settings) - Change fail. Evid: 1452.
 * Event description: Change event attempt: save/toggle in the setting section.

 * answers_brand_id - Type: guid.
 *
 * change_content - Type: string. Desc: json with all the changed information
 *
 * changeType - Type: string. Desc: {delete/create/update}
 *
 * client_id - Type: guid. Desc: client_id
 *
 * errorReason - Type: string. Desc: Reason for fail
 *
 * lang - Type: string. Desc: answers language
 *
 * page_url - Type: url. Desc: page_url
 *
 * section_key - Type: string. Desc: specific section that user tried to change
 *
 * source_name - Type: string. Desc: hc-1 / hc-2
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appSettingsChangeFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsChangeFail = function (params) {
    return { evid: 1452, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsCloseCccModalParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} current_balance - Current CCC balance
* @property {boolean} is_premium - Is the tenant Premium or Free
* @property {string} origin - CCC modal origin
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Close CCC Modal. Evid: 1862.
 * Event description: Call Center Credits (CCC) modal lightbox closed.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * current_balance - Type: string. Desc: Current CCC balance
 *
 * is_premium - Type: bool. Desc: Is the tenant Premium or Free
 *
 * origin - Type: string. Desc: CCC modal origin
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsCloseCccModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsCloseCccModal = function (params) {
    return { evid: 1862, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamCancelGroupChangesClickParams
* @property {number} amount_members_added - amount members added (minus if removed)
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} group_id - group id
* @property {string} group_name - group name
* @property {boolean} is_name_changed - is group name changed?
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} source - {Edit group/New group}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Cancel group changes click. Evid: 1209.
 * Event description: Clicking "Cancel" after editing a group.

 * amount_members_added - Type: numeric. Desc: amount members added (minus if removed)
 *
 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * group_id - Type: guid. Desc: group id
 *
 * group_name - Type: string. Desc: group name
 *
 * is_name_changed - Type: bool. Desc: is group name changed?
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Edit group/New group}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamCancelGroupChangesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamCancelGroupChangesClick = function (params) {
    return { evid: 1209, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsSelectAmountForPurchaseParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} credits_amount - Selected amount of credits
* @property {string} current_balance - Current CCC balance
* @property {string} origin - CCC modal origin
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Select amount for purchase. Evid: 1865.
 * Event description: User selected the amount of call center credits for purchase.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * credits_amount - Type: string. Desc: Selected amount of credits
 *
 * current_balance - Type: string. Desc: Current CCC balance
 *
 * origin - Type: string. Desc: CCC modal origin
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsSelectAmountForPurchaseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsSelectAmountForPurchase = function (params) {
    return { evid: 1865, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbArticlesListCreateArticleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - article_id
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - category/subcategory id
* @property {string} permission_level - User's permission level
* @property {string} source - {articles list, categories screen}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Create new article click. Evid: 1109.
 * Event description: Click on the button to "Create new article".

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: article_id
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category/subcategory id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {articles list, categories screen}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbArticlesListCreateArticleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbArticlesListCreateArticle = function (params) {
    return { evid: 1109, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpSubmitSignUpSecondStepParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers client ID
* @property {number} campaign_id - DEPRECATE
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {string} subdomain - Answers URL
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - Answers uuid
**/
/**
 * Name: Marketing (Sign Up) - Submit Sign Up - second step. Evid: 106.
 * Event description: User sign up attempt on the second step of sign in flow of organization registartion.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers client ID
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * subdomain - Type: string. Desc: Answers URL
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 * @param {marketingSignUpSubmitSignUpSecondStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpSubmitSignUpSecondStep = function (params) {
    return { evid: 106, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsRolesAgentClickAddCustomRoleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID
**/
/**
 * Name: App (Settings) - Roles -  Agent click "Add custom role". Evid: 1454.
 * Event description: An agent clicks "Add custom role" inside "roles" section of Answers Settings.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID
 * @param {appSettingsRolesAgentClickAddCustomRoleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsRolesAgentClickAddCustomRole = function (params) {
    return { evid: 1454, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxDeleteATicketConfirmParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {boolean} is_blocked - Did the user check the "block user" check
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {number} status_id - status id
* @property {string} status_name - status name
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Delete a ticket confirm. Evid: 1010.
 * Event description: Delete a ticket from the action bar confirm - click the red button. event is triggered from both Tickets and One Inbox modules,.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * is_blocked - Type: bool. Desc: Did the user check the "block user" check
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * status_id - Type: numeric. Desc: status id
 *
 * status_name - Type: string. Desc: status name
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxDeleteATicketConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxDeleteATicketConfirm = function (params) {
    return { evid: 1010, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingWatchAVideoPressOnButtonParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - Answers user id
**/
/**
 * Name: Marketing  - Watch a video - Press on button. Evid: 120.
 * Event description: The user Click on "Watch a video" (a button on the first fold which will link to our YT video).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid. Desc: Answers user id
 * @param {marketingWatchAVideoPressOnButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingWatchAVideoPressOnButton = function (params) {
    return { evid: 120, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpClickSignUpWithSsoParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers uuid
* @property {number} campaign_id - DEPRECATE
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {string} sso_type - wix/ google / facebook
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - answers ID
**/
/**
 * Name: Marketing (Sign Up) - Click sign up with SSO. Evid: 101.
 * Event description: Click on the "Signup with .." button on the first personal step of sign up flow.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers uuid
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * sso_type - Type: string. Desc: wix/ google / facebook
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: answers ID
 * @param {marketingSignUpClickSignUpWithSsoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpClickSignUpWithSso = function (params) {
    return { evid: 101, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxClickOnATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {number} position - position of the ticket in the page (1,2,3...)
* @property {string} source - {Ticket list, email, notification list...}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Click on a ticket. Evid: 1007.
 * Event description: Click on a ticket from the list. event is triggered from both Tickets and One Inbox modules..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * position - Type: numeric. Desc: position of the ticket in the page (1,2,3...)
 *
 * source - Type: string. Desc: {Ticket list, email, notification list...}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxClickOnATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxClickOnATicket = function (params) {
    return { evid: 1007, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} devBindingAnswersAndWixIdentifiersParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers Client (Anonymous) ID
* @property {GUID} user_id - Answers User ID
* @property {GUID} wix_client_id - Wix Client (Anonymous) ID
* @property {GUID} wix_user_id - Wix User ID
**/
/**
 * Name: Dev - Binding Answers and Wix Identifiers. Evid: 50.
 * Event description: Event is fired every time that: 1. A user loads the Answers Marketing site or the Answers App  2. A wixCIDX and/or wixUIDX cookie was detected.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers Client (Anonymous) ID
 *
 * user_id - Type: guid. Desc: Answers User ID
 *
 * wix_client_id - Type: guid. Desc: Wix Client (Anonymous) ID
 *
 * wix_user_id - Type: guid. Desc: Wix User ID
 * @param {devBindingAnswersAndWixIdentifiersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var devBindingAnswersAndWixIdentifiers = function (params) {
    return { evid: 50, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumCcCreditsOpenPackagePickerParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} current_balance - Current CCC balance
* @property {string} origin - CCC modal origin
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - CC Credits - Open Package Picker. Evid: 1864.
 * Event description: Call Center Credits (CCC) Package Picker opened successfully..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * current_balance - Type: string. Desc: Current CCC balance
 *
 * origin - Type: string. Desc: CCC modal origin
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumCcCreditsOpenPackagePickerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumCcCreditsOpenPackagePicker = function (params) {
    return { evid: 1864, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} statusPageBannerLoadedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} incident_name - The title of the incident fetched from the status page
* @property {boolean} resolved - State of the Incident
* @property {GUID} user_id - null
**/
/**
 * Name: Status Page Banner loaded. Evid: 45.
 * Event description: Status Page Banner loaded.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * incident_name - Type: string. Desc: The title of the incident fetched from the status page
 *
 * resolved - Type: bool. Desc: State of the Incident
 *
 * user_id - Type: guid.
 * @param {statusPageBannerLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var statusPageBannerLoaded = function (params) {
    return { evid: 45, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - Answers total plan price
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - Monthly / Yearly
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker -  Third step - Choose subscription cycle. Evid: 1817.
 * Event description: Answers PP Third step - Choose Answers subscription cycle:
Monthly / Yearly.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: Answers total plan price
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: Monthly / Yearly
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerThirdStepChooseSubscriptionCycle = function (params) {
    return { evid: 1817, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsTicketSnoozeStartParams
* @property {GUID} answers_brand_id - null
* @property {boolean} change_status_to_open - Does end of snooze should change ticket status to open (True/False)
* @property {GUID} client_id - null
* @property {boolean} costumer_reply_unsnooze - Should snooze be ended (canceled) if user reply the ticket (True/False)
* @property {boolean} is_from_bulk - True - if the Snooze triggered as part of bulk Action, False - If not
* @property {boolean} is_snooze_update - True- if  it is a Snooze update, False - if it is a "New Snooze"
* @property {DateTime} last_snooze_time - If it is a Snooze Update, what was the last Snooze time before the update
* @property {GUID} macro_id - Phase 2 - If done by Macro - Macro ID, if not - Null
* @property {string} operator - Phase 2 - Who made the action (Member, Macro, Spotter)
* @property {GUID} scenario_id - Phase 2 - If done by Spotter - Scenario ID, if not - Null
* @property {boolean} send_notification - True / False - according to snooze settings
* @property {GUID} snooze_id - ID of the Snooze
* @property {DateTime} snooze_time - The Time the ticket was set to be snoozed
* @property {string} snooze_type - The type of Snooze time reference used (Later today, Tomorrow, next week, choose Date & Time)
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} ticket_id - The Id of the Ticket being snoozed
* @property {GUID} user_id - Answers User ID of the member updating the snooze
* @property {string} week_start_day - TBD - The first day of the week according to the snooze settings (Sunday, Monday)
**/
/**
 * Name: App (One Inbox) -  Ticket Snooze Start or Update. Evid: 1029.
 * Event description: A ticket has been snoozed by an Answers member..

 * answers_brand_id - Type: guid.
 *
 * change_status_to_open - Type: bool. Desc: Does end of snooze should change ticket status to open (True/False)
 *
 * client_id - Type: guid.
 *
 * costumer_reply_unsnooze - Type: bool. Desc: Should snooze be ended (canceled) if user reply the ticket (True/False)
 *
 * is_from_bulk - Type: bool. Desc: True - if the Snooze triggered as part of bulk Action, False - If not
 *
 * is_snooze_update - Type: bool. Desc: True- if  it is a Snooze update, False - if it is a "New Snooze"
 *
 * last_snooze_time - Type: datetime. Desc: If it is a Snooze Update, what was the last Snooze time before the update
 *
 * macro_id - Type: guid. Desc: Phase 2 - If done by Macro - Macro ID, if not - Null
 *
 * operator - Type: string. Desc: Phase 2 - Who made the action (Member, Macro, Spotter)
 *
 * scenario_id - Type: guid. Desc: Phase 2 - If done by Spotter - Scenario ID, if not - Null
 *
 * send_notification - Type: bool. Desc: True / False - according to snooze settings
 *
 * snooze_id - Type: guid. Desc: ID of the Snooze
 *
 * snooze_time - Type: datetime. Desc: The Time the ticket was set to be snoozed
 *
 * snooze_type - Type: string. Desc: The type of Snooze time reference used (Later today, Tomorrow, next week, choose Date & Time)
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_id - Type: guid. Desc: The Id of the Ticket being snoozed
 *
 * user_id - Type: guid. Desc: Answers User ID of the member updating the snooze
 *
 * week_start_day - Type: string. Desc: TBD - The first day of the week according to the snooze settings (Sunday, Monday)
 * @param {appTicketsTicketSnoozeStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsTicketSnoozeStart = function (params) {
    return { evid: 1029, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsRemoveRelatedArticleFromATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - linked article id
* @property {string} article_name - linked article name
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - related ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Remove related article from a ticket. Evid: 1002.
 * Event description: Remove a related article from a ticket.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: linked article id
 *
 * article_name - Type: string. Desc: linked article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: related ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsRemoveRelatedArticleFromATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsRemoveRelatedArticleFromATicket = function (params) {
    return { evid: 1002, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsChangeAttemptParams
* @property {GUID} answers_brand_id - null
* @property {string} change_content - json with all the changed information
* @property {string} changeType - {delete/create/update}
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {Url} page_url - page_url
* @property {string} section_key - specific section that user tried to change
* @property {string} source_name - hc-1 / hc-2
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (Settings) - Change attempt. Evid: 1450.
 * Event description: Change event attempt: save/toggle in the setting section.

 * answers_brand_id - Type: guid.
 *
 * change_content - Type: string. Desc: json with all the changed information
 *
 * changeType - Type: string. Desc: {delete/create/update}
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * page_url - Type: url. Desc: page_url
 *
 * section_key - Type: string. Desc: specific section that user tried to change
 *
 * source_name - Type: string. Desc: hc-1 / hc-2
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appSettingsChangeAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsChangeAttempt = function (params) {
    return { evid: 1450, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerPurchaseFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {string} reason - Error reason
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Purchase Fail. Evid: 1834.
 * Event description: User fails to purchase.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * reason - Type: string. Desc: Error reason
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerPurchaseFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerPurchaseFail = function (params) {
    return { evid: 1834, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicCustomerPortalViewerClientEngagementParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} data - Json of Data related to the member's engagement.
* @property {string} engaged_component - What "component" the member clicked/engaged with.
* @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with.
* @property {string} engagement_name - The name of the Engagement
* @property {string} lang - Answers language
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: Public (Customer Portal) - Viewer Client Engagement. Evid: 2400.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: Json of Data related to the member's engagement.
 *
 * engaged_component - Type: string. Desc: What "component" the member clicked/engaged with.
 *
 * engaged_sub_component - Type: string. Desc: What "sub component" the member clicked/engaged with.
 *
 * engagement_name - Type: string. Desc: The name of the Engagement
 *
 * lang - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {publicCustomerPortalViewerClientEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicCustomerPortalViewerClientEngagement = function (params) {
    return { evid: 2400, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} clickOnEscalateToVistaButtonParams
* @property {GUID} agent_id - The expert that clicked on the button
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} country - the vista user country
* @property {string} description - The issue description of the user
* @property {boolean} is_action_successful - Did the action of the expert was approved
* @property {string} language - the vista user language
* @property {GUID} ticket_id - The vista ticket
* @property {GUID} uuid - the vista user
* @property {GUID} user_id - null
**/
/**
 * Name: Click on Escalate to Vista Button. Evid: 4914.
 * Event description: Button appears to experts only for Vista Users threads. The experts clicks on this button if he wants to request a callback from Vista CC to the user..

 * agent_id - Type: guid. Desc: The expert that clicked on the button
 *
 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * country - Type: string. Desc: the vista user country
 *
 * description - Type: string. Desc: The issue description of the user
 *
 * is_action_successful - Type: bool. Desc: Did the action of the expert was approved
 *
 * language - Type: string. Desc: the vista user language
 *
 * ticket_id - Type: guid. Desc: The vista ticket
 *
 * uuid - Type: guid. Desc: the vista user
 *
 * user_id - Type: guid.
 * @param {clickOnEscalateToVistaButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnEscalateToVistaButton = function (params) {
    return { evid: 4914, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamRemoveTeamMemberFromInvitationParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Remove team member from invitation. Evid: 1211.
 * Event description: Click on the "X" button in members invitation.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamRemoveTeamMemberFromInvitationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamRemoveTeamMemberFromInvitation = function (params) {
    return { evid: 1211, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLearnMorePressOnButtonParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {string} section_name - section name
* @property {GUID} user_id - Answers user id
**/
/**
 * Name: Marketing  - Learn more - Press on button. Evid: 121.
 * Event description: The user Click on "Learn more" (a button which will be added below each Product on the home page, linking to the product's specific page).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * section_name - Type: string. Desc: section name
 *
 * user_id - Type: guid. Desc: Answers user id
 * @param {marketingLearnMorePressOnButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLearnMorePressOnButton = function (params) {
    return { evid: 121, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appControlRoomAMemberClientEngagementParams
* @property {GUID} answers_brand_id - null
* @property {GUID} answers_role_id - Role Id of the Answers member loading the page
* @property {GUID} client_id - null
* @property {string} data - Json of Data directly related to the member's click/engagement.
* @property {string} engaged_component - What "component" the member clicked/engaged with. Examples: main table, upper tool bar, etc.
* @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with. Examples: (1) Edit Groups modal (2) update queues modal
* @property {string} engagement_name - The engagement the member is doing
* @property {string} lang - Answers language
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (Control Room) - A member Client Engagement. Evid: 2600.
 * Event description: A generic event covering the following member's Client engagements:
(1) Click on agent from main table
(2) Assign members to channels - data = {multi channel (True/False), multi members (True/False)}
(3) Click unassign members  from all channels - data = { multi members (True/False)}
(4) Set members workloads - data = {multi channel (True/False), multi members (True/False)}
(5) reset members workloads to account settings - data {multi members (True/False)}
(6) Update members groups - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
(7) Click on manage groups
Update members queues - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
(8) Click on manage queues
(9) Click on search bar
(10) Start typing in search bar. for more details: https://docs.google.com/document/d/1IT8vPXK0mDTTVnI3TSF3__Ti_dXvB8E2SVZnCwe7AFs/edit.

 * answers_brand_id - Type: guid.
 *
 * answers_role_id - Type: guid. Desc: Role Id of the Answers member loading the page
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: Json of Data directly related to the member's click/engagement.
 *
 * engaged_component - Type: string. Desc: What "component" the member clicked/engaged with. Examples: main table, upper tool bar, etc.
 *
 * engaged_sub_component - Type: string. Desc: What "sub component" the member clicked/engaged with. Examples: (1) Edit Groups modal (2) update queues modal
 *
 * engagement_name - Type: string. Desc: The engagement the member is doing
 *
 * lang - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appControlRoomAMemberClientEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appControlRoomAMemberClientEngagement = function (params) {
    return { evid: 2600, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamSaveGroupChangesClickParams
* @property {number} amount_members_added - amount members added (minus if removed)
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} group_id - group id
* @property {string} group_name - group name
* @property {boolean} is_name_changed - is group name changed?
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} source - {Edit group/New group}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Save group changes click. Evid: 1208.
 * Event description: Clicking "Save" after editing a group.

 * amount_members_added - Type: numeric. Desc: amount members added (minus if removed)
 *
 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * group_id - Type: guid. Desc: group id
 *
 * group_name - Type: string. Desc: group name
 *
 * is_name_changed - Type: bool. Desc: is group name changed?
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Edit group/New group}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamSaveGroupChangesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamSaveGroupChangesClick = function (params) {
    return { evid: 1208, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingUpdatePaymentMethodFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} reason - Reason of failure
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing -  Update Payment Method Fail. Evid: 1462.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * reason - Type: string. Desc: Reason of failure
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingUpdatePaymentMethodFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingUpdatePaymentMethodFail = function (params) {
    return { evid: 1462, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetSuggestedArticlesReportParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - selected article id
* @property {string} article_name - selected article name
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_name - where the widget is opened from (source page name)
* @property {string} parent_url - parent_url
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: Public (Widget) - Suggested articles - I want to report. Evid: 2250.
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "No! I want to report my issue"..

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: selected article id
 *
 * article_name - Type: string. Desc: selected article name
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_name - Type: string. Desc: where the widget is opened from (source page name)
 *
 * parent_url - Type: string. Desc: parent_url
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {publicWidgetSuggestedArticlesReportParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetSuggestedArticlesReport = function (params) {
    return { evid: 2250, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsSearchForATicketParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} first_answer - Title of first ticket shown to the user
* @property {string} lang - answers lang
* @property {number} number_of_related_tickets - number of returned tickets
* @property {string} permission_level - User's permission level
* @property {string} search_term - the string used to search a ticket
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Search for a ticket. Evid: 1004.
 * Event description: Search for a ticket in the search line.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * first_answer - Type: string. Desc: Title of first ticket shown to the user
 *
 * lang - Type: string. Desc: answers lang
 *
 * number_of_related_tickets - Type: numeric. Desc: number of returned tickets
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * search_term - Type: string. Desc: the string used to search a ticket
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTicketsSearchForATicketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsSearchForATicket = function (params) {
    return { evid: 1004, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step user click
* @property {string} origin - upgrade origin component
* @property {number} plan_price - Total Answers plan price
* @property {string} plan_type - Unlimited plan/ Custom plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge_base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - monthly/yearly subscription
* @property {string} team_size - The max number of agents
* @property {GUID} tenant_id - answers tenant id
* @property {boolean} unlimited_selected - relevant only for unlimited plan: user select unlimited =1 ,user checked 3 products=0
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Second step - User selected unlimited plan. Evid: 1816.
 * Event description: Answers PP Second step - User clicked on Unlimited plan select button or 3 products custom plan selected.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step user click
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: Total Answers plan price
 *
 * plan_type - Type: string. Desc: Unlimited plan/ Custom plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge_base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: monthly/yearly subscription
 *
 * team_size - Type: string. Desc: The max number of agents
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * unlimited_selected - Type: bool. Desc: relevant only for unlimited plan: user select unlimited =1 ,user checked 3 products=0
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan = function (params) {
    return { evid: 1816, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralClientLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {Url} page_url - page_url
* @property {string} permission_level - User's permission level
* @property {string} referral_name - referral_name
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (General) - Client Load Success. Evid: 1955.
 * Event description: Sent when the client app was fully rendered (all ajax requests completed, etc) - before all the modules are loaded.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * page_url - Type: url. Desc: page_url
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appGeneralClientLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralClientLoadSuccess = function (params) {
    return { evid: 1955, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbArticlesListSearchParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} first_answer - The first article shown to the user (on the left side) - article id
* @property {string} lang - answers language
* @property {number} number_of_related_articles - number of returned articles in answer
* @property {string} permission_level - User's permission level
* @property {string} search_term - What the user typed
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Articles list - Search article. Evid: 1108.
 * Event description: When the user searches for an article.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * first_answer - Type: string. Desc: The first article shown to the user (on the left side) - article id
 *
 * lang - Type: string. Desc: answers language
 *
 * number_of_related_articles - Type: numeric. Desc: number of returned articles in answer
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * search_term - Type: string. Desc: What the user typed
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbArticlesListSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbArticlesListSearch = function (params) {
    return { evid: 1108, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamInviteTeamMembersClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Invite team members click. Evid: 1201.
 * Event description: Click on the "Invite team member" button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamInviteTeamMembersClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamInviteTeamMembersClick = function (params) {
    return { evid: 1201, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerPreviewRenderFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Preview Render Fail. Evid: 1839.
 * Event description: Order preview fails to render.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerPreviewRenderFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerPreviewRenderFail = function (params) {
    return { evid: 1839, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicAUserClickOnDidThisArticleHelpBannerParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - article_id
* @property {string} article_name - article_name
* @property {GUID} client_id - null
* @property {boolean} help_or_not - 0 - "No, I still need help", 1- "Yes my issue is solved"
* @property {string} locale - Answers language
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} ticket_id - The ticket id that the article was recommended for
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: Public - A user click on "Did this article help?" banner. Evid: 2532.
 * Event description: The event is triggered when a user click "Yes my issue is solved" or "No, I still need help" on "Did this article help?" banner while viewing this article. (currently the only flow that should allow it, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation)).

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: article_id
 *
 * article_name - Type: string. Desc: article_name
 *
 * client_id - Type: guid.
 *
 * help_or_not - Type: bool. Desc: 0 - "No, I still need help", 1- "Yes my issue is solved"
 *
 * locale - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * ticket_id - Type: guid. Desc: The ticket id that the article was recommended for
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {publicAUserClickOnDidThisArticleHelpBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicAUserClickOnDidThisArticleHelpBanner = function (params) {
    return { evid: 2532, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerEnterpriseRequestCallbackParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Enterprise Request Callback. Evid: 1828.
 * Event description: User requests callback (CTA button) after selecting the enterprise solution (50+), which opens the widget.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerEnterpriseRequestCallbackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerEnterpriseRequestCallback = function (params) {
    return { evid: 1828, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerFirstStepUserSelectTeamSizeParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - plan price depend on tenant selection of number of agents and plan selection
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - monthly/yearly subscription
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - First step - User select team size. Evid: 1813.
 * Event description: Answers PP First step - User select team size (radio button) :
{2-5, 6-10, 11-20, 21-50, 51-100,100+ (-1)}
(All 'product' and 'plan' attributes will be NULL when the other steps are not exposed but not if they changed after advanced steps.).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: plan price depend on tenant selection of number of agents and plan selection
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: monthly/yearly subscription
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerFirstStepUserSelectTeamSizeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerFirstStepUserSelectTeamSize = function (params) {
    return { evid: 1813, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbCategoriesAddCategoryStartParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - If category - null, if subcategory - category's id
* @property {string} permission_level - User's permission level
* @property {string} source - {side bar/main screen}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Categories - Add category/subcategory click. Evid: 1111.
 * Event description: Click on the button "+ Add category".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: If category - null, if subcategory - category's id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {side bar/main screen}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbCategoriesAddCategoryStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbCategoriesAddCategoryStart = function (params) {
    return { evid: 1111, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetOpenAWidgetParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} open_method - open method {api,click}
* @property {string} parent_name - where the widget is opened from (source page name)
* @property {string} parent_url - where the widget is opened from (source page url)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: Public (Widget) - Open a widget. Evid: 2200.
 * Event description: Click on the widget icon in order to open it.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * open_method - Type: string. Desc: open method {api,click}
 *
 * parent_name - Type: string. Desc: where the widget is opened from (source page name)
 *
 * parent_url - Type: string. Desc: where the widget is opened from (source page url)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {publicWidgetOpenAWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetOpenAWidget = function (params) {
    return { evid: 2200, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLogInFailedUserLoginParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers uuid
* @property {string} error_reason - failed reason
* @property {string} login_type - wix/ google / facebook/ emial
* @property {Url} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {string} subdomain - answers subdomain
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - answers ID
**/
/**
 * Name: Marketing (Log In) - Failed User Login. Evid: 116.
 * Event description: User failed to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers uuid
 *
 * error_reason - Type: string. Desc: failed reason
 *
 * login_type - Type: string. Desc: wix/ google / facebook/ emial
 *
 * page_url - Type: url. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * subdomain - Type: string. Desc: answers subdomain
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: answers ID
 * @param {marketingLogInFailedUserLoginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLogInFailedUserLogin = function (params) {
    return { evid: 116, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamRemoveTeamMemberCancelParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} team_member_permission_level - {admin/agent}
* @property {GUID} team_member_uuid - team member uuid
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Remove team member cancel. Evid: 1214.
 * Event description: Click "cancel" button after being asked "Are you sure?".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * team_member_permission_level - Type: string. Desc: {admin/agent}
 *
 * team_member_uuid - Type: guid. Desc: team member uuid
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamRemoveTeamMemberCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamRemoveTeamMemberCancel = function (params) {
    return { evid: 1214, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralFtueVideoLightboxPlayVideoParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the feature the lightbox is shown in
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (General) - FTUE Video Lightbox - Play Video. Evid: 1948.
 * Event description: User clicks the "Play" button of the video in the First Time User Experience (FTUE) Video Lightbox of a certain feature.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the feature the lightbox is shown in
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appGeneralFtueVideoLightboxPlayVideoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralFtueVideoLightboxPlayVideo = function (params) {
    return { evid: 1948, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSelectSubscriptionCycleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Select Subscription Cycle. Evid: 1826.
 * Event description: User selects subscription cycle - the whole strip is clickable, not just radio button (Monthly / Yearly / 2 Years).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerSelectSubscriptionCycleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSelectSubscriptionCycle = function (params) {
    return { evid: 1826, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appInsightsAdvancedReportsWasabiDashboardLoadStartParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} dashboard_filters - Applied filters on that dashboard run
* @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
* @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
* @property {string} dashboard_title - Looker Dashboard Title
* @property {string} looker_dashboard_id - Looker Dashboard ID
* @property {GUID} tenant_id - Answers Tenant ID
* @property {GUID} user_id - Performing User ID
**/
/**
 * Name: App (Insights) - Advanced Reports (Wasabi) - Dashboard Load Start. Evid: 1320.
 * Event description: This event is fired when a dashboard has begun loading, when its tiles will start loading and querying for data..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * dashboard_filters - Type: string. Desc: Applied filters on that dashboard run
 *
 * dashboard_load_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 *
 * dashboard_refresh_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 *
 * dashboard_title - Type: string. Desc: Looker Dashboard Title
 *
 * looker_dashboard_id - Type: string. Desc: Looker Dashboard ID
 *
 * tenant_id - Type: guid. Desc: Answers Tenant ID
 *
 * user_id - Type: guid. Desc: Performing User ID
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appInsightsAdvancedReportsWasabiDashboardLoadStart = function (params) {
    return { evid: 1320, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} statusPageReportedAProblemParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} description - description
* @property {string} service - Edit or Publish a site, Access site, Other
* @property {GUID} user_id - null
**/
/**
 * Name: Status Page - reported a problem. Evid: 46.
 * Event description: User clicked on “I have a problem” button on the External Wix Status Page.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * description - Type: string. Desc: description
 *
 * service - Type: string. Desc: Edit or Publish a site, Access site, Other
 *
 * user_id - Type: guid.
 * @param {statusPageReportedAProblemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var statusPageReportedAProblem = function (params) {
    return { evid: 46, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicCloseAWidgetClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} close_method - close method {click,api}
* @property {string} locale - Answers language
* @property {string} module_name - last used module (home, chat, contact form, etc)
* @property {string} parent_name - parent_name
* @property {string} parent_url - parent_url
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: Public (Widget) - Close a widget click (Client). Evid: 2210.
 * Event description: Click on the widget close (X) icon in order to close it.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * close_method - Type: string. Desc: close method {click,api}
 *
 * locale - Type: string. Desc: Answers language
 *
 * module_name - Type: string. Desc: last used module (home, chat, contact form, etc)
 *
 * parent_name - Type: string. Desc: parent_name
 *
 * parent_url - Type: string. Desc: parent_url
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {publicCloseAWidgetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicCloseAWidgetClick = function (params) {
    return { evid: 2210, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbRenameCategorySubcategoryParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - only relevant for subcategories {side menu, main menu}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - uuid
**/
/**
 * Name: App (KB) - Rename category/subcategory. Evid: 1123.
 * Event description: Rename a category or a subcategory.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: only relevant for subcategories {side menu, main menu}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: uuid
 * @param {appKbRenameCategorySubcategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbRenameCategorySubcategory = function (params) {
    return { evid: 1123, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerPurchaseAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Purchase Attempt. Evid: 1832.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerPurchaseAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerPurchaseAttempt = function (params) {
    return { evid: 1832, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} dashboard_filters - Applied filters on that dashboard run
* @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
* @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
* @property {string} dashboard_title - Looker Dashboard Title
* @property {string} looker_dashboard_id - Looker Dashboard ID
* @property {string} status_name - Indicates whether the dashboard and its elements have successfully run, failed, or stopped before finished running
* @property {GUID} tenant_id - Answers Tenant ID
* @property {GUID} user_id - Performing User ID
**/
/**
 * Name: App (Insights) - Advanced Reports (Wasabi) - Dashboard Load Complete. Evid: 1321.
 * Event description: This event is fired when a dashboard has finished running and all tiles have finished loading and querying. This event is fired whether or not all tiles load successfully..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * dashboard_filters - Type: string. Desc: Applied filters on that dashboard run
 *
 * dashboard_load_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 *
 * dashboard_refresh_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 *
 * dashboard_title - Type: string. Desc: Looker Dashboard Title
 *
 * looker_dashboard_id - Type: string. Desc: Looker Dashboard ID
 *
 * status_name - Type: string. Desc: Indicates whether the dashboard and its elements have successfully run, failed, or stopped before finished running
 *
 * tenant_id - Type: guid. Desc: Answers Tenant ID
 *
 * user_id - Type: guid. Desc: Performing User ID
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appInsightsAdvancedReportsWasabiDashboardLoadComplete = function (params) {
    return { evid: 1321, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsSwitchReplyTypeParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - saved reply id
* @property {string} switch_to - desired reply mode {team note/reply}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets) - Switch reply type. Evid: 1019.
 * Event description: Team Note - Switch reply type.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: saved reply id
 *
 * switch_to - Type: string. Desc: desired reply mode {team note/reply}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsSwitchReplyTypeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsSwitchReplyType = function (params) {
    return { evid: 1019, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpStartSignUpFlowParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers client id
* @property {number} campaign_id - The field will be deprecated
* @property {string} locale - Answers language
* @property {string} location - The field will be deprecated
* @property {GUID} marketing_id - The field will be deprecated
* @property {string} permission_level - The field will be deprecated
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - A unique guid for sign up flow
* @property {GUID} tenant_id - tenant of the performing user
* @property {GUID} user_id - Answers uuid
**/
/**
 * Name: Marketing (Sign Up) - Start sign up flow. Evid: 100.
 * Event description: Click on one of the 'Get Started' buttons in wixanswers.com's homepage / 'Don't have an account? Sign Up here' on login first step (page 'Enter Your Wix Answers Domain').

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers client id
 *
 * campaign_id - Type: numeric. Desc: The field will be deprecated
 *
 * locale - Type: string. Desc: Answers language
 *
 * location - Type: string. Desc: The field will be deprecated
 *
 * marketing_id - Type: guid. Desc: The field will be deprecated
 *
 * permission_level - Type: string. Desc: The field will be deprecated
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: A unique guid for sign up flow
 *
 * tenant_id - Type: guid. Desc: tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 * @param {marketingSignUpStartSignUpFlowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpStartSignUpFlow = function (params) {
    return { evid: 100, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appControlRoomPageLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {number} attempt_outbound_calls_position - The position of this column in the main table, if not presented = 0
* @property {number} avg_call_duration_position - The position of this column in the main table, if not presented = 0
* @property {number} avg_completed_call_duration_position - null
* @property {number} avg_handling_tickets_duration_position - The position of this column in the main table, if not presented = 0
* @property {number} call_workload_position - null
* @property {number} channel_position - The position of this column in the main table, if not presented = 0
* @property {number} chat_workload_position - null
* @property {GUID} client_id - null
* @property {number} completed_calls_position - The position of this column in the main table, if not presented = 0
* @property {number} completed_chats_position - null
* @property {number} completed_handling_tickets_position - The position of this column in the main table, if not presented = 0
* @property {number} email_workload_position - The position of this column in the main table, if not presented = 0
* @property {number} facebook_workload_position - The position of this column in the main table, if not presented = 0
* @property {number} groups_position - The position of this column in the main table, if not presented = 0
* @property {boolean} is_agentchannels - null
* @property {boolean} is_group - Does this filter applied or not
* @property {boolean} is_location - Does this filter applied or not
* @property {boolean} is_manager - Does this filter applied or not
* @property {boolean} is_queue - Does this filter applied or not
* @property {boolean} is_role - null
* @property {boolean} is_statuses - Does this filter applied or not
* @property {boolean} is_team - Does this filter applied or not
* @property {number} job_title_position - The position of this column in the main table, if not presented = 0
* @property {string} lang - null
* @property {number} languages_position - The position of this column in the main table, if not presented = 0
* @property {number} location_position - The position of this column in the main table, if not presented = 0
* @property {number} manager_position - The position of this column in the main table, if not presented = 0
* @property {number} median_call_duration_position - null
* @property {number} median_handling_tickets_duration_position - The position of this column in the main table, if not presented = 0
* @property {number} name_position - The position of this column in the main table, if not presented = 0
* @property {number} qualified_channels_position - The position of this column in the main table, if not presented = 0
* @property {number} queues_position - The position of this column in the main table, if not presented = 0
* @property {number} resolved_tickets_position - null
* @property {GUID} role_id - Answers Role ID
* @property {number} role_position - The position of this column in the main table, if not presented = 0
* @property {number} sms_workload_position - The position of this column in the main table, if not presented = 0
* @property {number} status_position - The position of this column in the main table, if not presented = 0
* @property {number} team_position - null
* @property {GUID} tenant_id - Answers tenant ID
* @property {string} time_frame - The time frame being viewed (Last hour, Last 3 Hours etc.)
* @property {number} total_call_duration_position - null
* @property {number} total_calls_position - null
* @property {number} total_columns_presented - Total number of presented columns in the main table
* @property {number} total_completed_call_duration_position - The position of this column in the main table, if not presented = 0
* @property {number} total_filters_applied - null
* @property {number} total_handling_tickets_duration_position - null
* @property {number} total_replies_position - The position of this column in the main table, if not presented = 0
* @property {number} utilization_rate_position - The position of this column in the main table, if not presented = 0
* @property {GUID} user_id - null
* @property {number} whatsapp_workload_position - null
**/
/**
 * Name: App (Control Room) - Page Load Success. Evid: 2601.


 * answers_brand_id - Type: guid.
 *
 * attempt_outbound_calls_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * avg_call_duration_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * avg_completed_call_duration_position - Type: numeric.
 *
 * avg_handling_tickets_duration_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * call_workload_position - Type: numeric.
 *
 * channel_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * chat_workload_position - Type: numeric.
 *
 * client_id - Type: guid.
 *
 * completed_calls_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * completed_chats_position - Type: numeric.
 *
 * completed_handling_tickets_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * email_workload_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * facebook_workload_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * groups_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * is_agentchannels - Type: bool.
 *
 * is_group - Type: bool. Desc: Does this filter applied or not
 *
 * is_location - Type: bool. Desc: Does this filter applied or not
 *
 * is_manager - Type: bool. Desc: Does this filter applied or not
 *
 * is_queue - Type: bool. Desc: Does this filter applied or not
 *
 * is_role - Type: bool.
 *
 * is_statuses - Type: bool. Desc: Does this filter applied or not
 *
 * is_team - Type: bool. Desc: Does this filter applied or not
 *
 * job_title_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * lang - Type: string.
 *
 * languages_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * location_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * manager_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * median_call_duration_position - Type: numeric.
 *
 * median_handling_tickets_duration_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * name_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * qualified_channels_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * queues_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * resolved_tickets_position - Type: numeric.
 *
 * role_id - Type: guid. Desc: Answers Role ID
 *
 * role_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * sms_workload_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * status_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * team_position - Type: numeric.
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * time_frame - Type: string. Desc: The time frame being viewed (Last hour, Last 3 Hours etc.)
 *
 * total_call_duration_position - Type: numeric.
 *
 * total_calls_position - Type: numeric.
 *
 * total_columns_presented - Type: numeric. Desc: Total number of presented columns in the main table
 *
 * total_completed_call_duration_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * total_filters_applied - Type: numeric.
 *
 * total_handling_tickets_duration_position - Type: numeric.
 *
 * total_replies_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * utilization_rate_position - Type: numeric. Desc: The position of this column in the main table, if not presented = 0
 *
 * user_id - Type: guid.
 *
 * whatsapp_workload_position - Type: numeric.
 * @param {appControlRoomPageLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appControlRoomPageLoadSuccess = function (params) {
    return { evid: 2601, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingCampaignViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} campaign_id - campaign_id
* @property {string} campaign_name - campaign_name
* @property {GUID} client_id - Answers anonymous id
* @property {string} page_url - current page
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} user_id - user_id
**/
/**
 * Name: Marketing  - Campaign view. Evid: 124.
 * Event description: The user view a campaign page..

 * answers_brand_id - Type: guid.
 *
 * campaign_id - Type: guid. Desc: campaign_id
 *
 * campaign_name - Type: string. Desc: campaign_name
 *
 * client_id - Type: guid. Desc: Answers anonymous id
 *
 * page_url - Type: string. Desc: current page
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * user_id - Type: guid. Desc: user_id
 * @param {marketingCampaignViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingCampaignView = function (params) {
    return { evid: 124, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralClientLoadAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {Url} page_url - page_url
* @property {string} permission_level - User's permission level
* @property {string} referral_name - referral_name
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - user_id
**/
/**
 * Name: App (General) - Client Load Attempt. Evid: 1954.
 * Event description: Sent when the page is served and loaded, but the actual app was not fully rendered yet.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * page_url - Type: url. Desc: page_url
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid. Desc: user_id
 * @param {appGeneralClientLoadAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralClientLoadAttempt = function (params) {
    return { evid: 1954, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} clickOnStatusPageBannerParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} incident_name - The title of the incident fetched from the status page
* @property {boolean} resolved - State of the Incident
* @property {GUID} user_id - null
**/
/**
 * Name: Click on "Status Page" Banner. Evid: 44.
 * Event description: Click on "Status Page" Banner.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * incident_name - Type: string. Desc: The title of the incident fetched from the status page
 *
 * resolved - Type: bool. Desc: State of the Incident
 *
 * user_id - Type: guid.
 * @param {clickOnStatusPageBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnStatusPageBanner = function (params) {
    return { evid: 44, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleSaveAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {number} ts - amount of time (milliseconds) since "save" button clicked
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Edit article - Save attempt. Evid: 1100.
 * Event description: start save process after clicking "Save".

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ts - Type: numeric. Desc: amount of time (milliseconds) since "save" button clicked
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleSaveAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleSaveAttempt = function (params) {
    return { evid: 1100, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appInsightsAdvancedReportsWasabiTileLoadCompleteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} dashboard_filters - Applied filters on that dashboard run
* @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
* @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
* @property {string} dashboard_title - Looker Dashboard Title
* @property {string} looker_dashboard_id - Looker Dashboard ID
* @property {string} status_name - Whether the tile query completed successfully. Possible values are "complete" or "error"
* @property {GUID} tenant_id - Answers Tenant ID
* @property {string} tile_listen - The global dashboard filters this tile is listening for
* @property {string} tile_title - The tile title, as shown at the top of the tile
* @property {GUID} user_id - Performing User ID
**/
/**
 * Name: App (Insights) - Advanced Reports (Wasabi) - Tile Load Complete. Evid: 1323.
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * dashboard_filters - Type: string. Desc: Applied filters on that dashboard run
 *
 * dashboard_load_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 *
 * dashboard_refresh_id - Type: string. Desc: Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 *
 * dashboard_title - Type: string. Desc: Looker Dashboard Title
 *
 * looker_dashboard_id - Type: string. Desc: Looker Dashboard ID
 *
 * status_name - Type: string. Desc: Whether the tile query completed successfully. Possible values are "complete" or "error"
 *
 * tenant_id - Type: guid. Desc: Answers Tenant ID
 *
 * tile_listen - Type: string. Desc: The global dashboard filters this tile is listening for
 *
 * tile_title - Type: string. Desc: The tile title, as shown at the top of the tile
 *
 * user_id - Type: guid. Desc: Performing User ID
 * @param {appInsightsAdvancedReportsWasabiTileLoadCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appInsightsAdvancedReportsWasabiTileLoadComplete = function (params) {
    return { evid: 1323, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWidgetClientRequestsATokenForWidgetAuthenticationFromHostSiteParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Client ID of the user
* @property {string} locale - Answers language
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
**/
/**
 * Name: Public (Widget) - Client requests a Token for Widget authentication from host site. Evid: 2251.
 * Event description: Widget Client requests a Token for Widget authentication from host site.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Client ID of the user
 *
 * locale - Type: string. Desc: Answers language
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 * @param {publicWidgetClientRequestsATokenForWidgetAuthenticationFromHostSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWidgetClientRequestsATokenForWidgetAuthenticationFromHostSite = function (params) {
    return { evid: 2251, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} devGeneralAnswersFedEventParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} data - data
* @property {string} feature - feature
* @property {GUID} item_id - Item ID
* @property {string} module - module in the app (kb / ticketing / cc / chat / etc.)
* @property {GUID} tenant_id - tenant ID
* @property {string} type - event description
* @property {GUID} user_id - User ID
**/
/**
 * Name: Dev - General Answers FED Event. Evid: 42.
 * Event description: This is a general event that serves as "event candidate". Relevant events will be later developed as standalone events..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: data
 *
 * feature - Type: string. Desc: feature
 *
 * item_id - Type: guid. Desc: Item ID
 *
 * module - Type: string. Desc: module in the app (kb / ticketing / cc / chat / etc.)
 *
 * tenant_id - Type: guid. Desc: tenant ID
 *
 * type - Type: string. Desc: event description
 *
 * user_id - Type: guid. Desc: User ID
 * @param {devGeneralAnswersFedEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var devGeneralAnswersFedEvent = function (params) {
    return { evid: 42, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingClickUpdatePaymentMethodModalLinkParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing - Click Update Payment Method Modal Link. Evid: 1459.
 * Event description: Member clicks on the Update Payment Method link in the upper right corner of the Billing Page.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingClickUpdatePaymentMethodModalLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingClickUpdatePaymentMethodModalLink = function (params) {
    return { evid: 1459, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appOneInboxStartActiveSessionParams
* @property {GUID} answers_brand_id - null
* @property {GUID} answers_role_id - Answers Role ID
* @property {string} assigned_entity - Second phase - Is the ticket assigned to a Group or Member
* @property {GUID} assigned_entity_id - null
* @property {string} channel - The Channel of the ticket
* @property {GUID} client_id - null
* @property {string} lang - Answers language
* @property {number} member_existed_active_sessions - The number of active sessions the member already have
* @property {string} start_session_type - Take Ticket/Join Active session/start typing
* @property {GUID} tenant_id - Tenant ID
* @property {number} ticket_existed_active_sessions - The number of active sessions the ticket already have
* @property {GUID} ticket_id - Ticket ID
* @property {number} ticket_status_type - Second phase - Ticket Status
* @property {GUID} user_id - Answers user ID of the member loading the page
**/
/**
 * Name: App (One Inbox) - Start Active Session. Evid: 1031.
 * Event description: This Event is triggered every time a member is starting an active session by clicking the "Take Ticket"/"Join Active session" button or by start typing in the reply box..

 * answers_brand_id - Type: guid.
 *
 * answers_role_id - Type: guid. Desc: Answers Role ID
 *
 * assigned_entity - Type: string. Desc: Second phase - Is the ticket assigned to a Group or Member
 *
 * assigned_entity_id - Type: guid.
 *
 * channel - Type: string. Desc: The Channel of the ticket
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: Answers language
 *
 * member_existed_active_sessions - Type: numeric. Desc: The number of active sessions the member already have
 *
 * start_session_type - Type: string. Desc: Take Ticket/Join Active session/start typing
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_existed_active_sessions - Type: numeric. Desc: The number of active sessions the ticket already have
 *
 * ticket_id - Type: guid. Desc: Ticket ID
 *
 * ticket_status_type - Type: numeric. Desc: Second phase - Ticket Status
 *
 * user_id - Type: guid. Desc: Answers user ID of the member loading the page
 * @param {appOneInboxStartActiveSessionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOneInboxStartActiveSession = function (params) {
    return { evid: 1031, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicClickContactUsFooterParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} location_identifier - header/footer
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} source_id - source_id
* @property {string} source_name -
* @property {string} source_type - source_type
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Click on "Contact Us". Evid: 2500.
 * Event description: Click on "Contact Us".

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * location_identifier - Type: string. Desc: header/footer
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string.
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 * @param {publicClickContactUsFooterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicClickContactUsFooter = function (params) {
    return { evid: 2500, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleSaveSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {number} ts - amount of time (milliseconds) since save process started
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Edit article - Save success. Evid: 1101.
 * Event description: Finish save process.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ts - Type: numeric. Desc: amount of time (milliseconds) since save process started
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleSaveSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleSaveSuccess = function (params) {
    return { evid: 1101, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} callbackWidgetTicketCreationParams
* @property {GUID} agent_id - The Answers UUID of the agent who created a ticket using the widget
* @property {GUID} answers_brand_id - null
* @property {GUID} assigned_group_id - The guid of the group the created ticket is assigned to at ticket creation
* @property {GUID} client_id - null
* @property {GUID} line_id - The line ID we call the user from
* @property {GUID} queue_id - The guid of the queue in which the callback is created
* @property {GUID} source_ticket_id - The ticket guid from which the callback request is created, can be null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} ticket_id - The id of the ticket that was created using the widget
* @property {GUID} user_id - The Wix uuid of the user the callback is created for
**/
/**
 * Name: Callback Widget ticket creation. Evid: 4907.
 * Event description: Triggers whenever a new ticket is created via the callback request widget.

 * agent_id - Type: guid. Desc: The Answers UUID of the agent who created a ticket using the widget
 *
 * answers_brand_id - Type: guid.
 *
 * assigned_group_id - Type: guid. Desc: The guid of the group the created ticket is assigned to at ticket creation
 *
 * client_id - Type: guid.
 *
 * line_id - Type: guid. Desc: The line ID we call the user from
 *
 * queue_id - Type: guid. Desc: The guid of the queue in which the callback is created
 *
 * source_ticket_id - Type: guid. Desc: The ticket guid from which the callback request is created, can be null
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * ticket_id - Type: guid. Desc: The id of the ticket that was created using the widget
 *
 * user_id - Type: guid. Desc: The Wix uuid of the user the callback is created for
 * @param {callbackWidgetTicketCreationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var callbackWidgetTicketCreation = function (params) {
    return { evid: 4907, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingLogInSubmitPreLoginRedirectToAnswersUrlParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers client id
* @property {number} campaign_id - DEPRECATE
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {string} subdomain - Answers URL
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - Answers uuid
**/
/**
 * Name: Marketing (Log In) - Submit Pre-login (redirect to Answers URL). Evid: 109.
 * Event description: User attempts to continue with his login first step - recognize tenant URL.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers client id
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * subdomain - Type: string. Desc: Answers URL
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 * @param {marketingLogInSubmitPreLoginRedirectToAnswersUrlParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingLogInSubmitPreLoginRedirectToAnswersUrl = function (params) {
    return { evid: 109, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamRemoveTeamMemberClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} team_member_permission_level - {admin/agent}
* @property {GUID} team_member_uuid - team member uuid
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Remove team member click. Evid: 1212.
 * Event description: Click "Remove from team" button.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * team_member_permission_level - Type: string. Desc: {admin/agent}
 *
 * team_member_uuid - Type: guid. Desc: team member uuid
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamRemoveTeamMemberClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamRemoveTeamMemberClick = function (params) {
    return { evid: 1212, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingDownloadInvoiceFileParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} invoice_amount - Invoice Amount
* @property {DateTime} invoice_date - Invoice Date
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing - Download Invoice File. Evid: 1465.
 * Event description: Download Invoice file CTA in the invoice history list.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * invoice_amount - Type: numeric. Desc: Invoice Amount
 *
 * invoice_date - Type: datetime. Desc: Invoice Date
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingDownloadInvoiceFileParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingDownloadInvoiceFile = function (params) {
    return { evid: 1465, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumBlocksIncentiveViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the blocked feature
* @property {boolean} is_eligible - Is the user eligible to buy a premium plan
* @property {boolean} is_premium - Is the tenant Premium or Free
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Blocks -  Premium Incentive View. Evid: 1851.
 * Event description: An user views a premium incentive of a blocked premium feature.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the blocked feature
 *
 * is_eligible - Type: bool. Desc: Is the user eligible to buy a premium plan
 *
 * is_premium - Type: bool. Desc: Is the tenant Premium or Free
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumBlocksIncentiveViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumBlocksIncentiveView = function (params) {
    return { evid: 1851, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerCheckoutAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Checkout Attempt. Evid: 1829.
 * Event description: User attempts to checkout (CTA button).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerCheckoutAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerCheckoutAttempt = function (params) {
    return { evid: 1829, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumBlocksIncentiveCtaClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the blocked feature
* @property {boolean} is_eligible - Is the user eligible to buy a premium plan
* @property {boolean} is_premium - Is the tenant Premium or Free
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Blocks - Premium Incentive CTA Click. Evid: 1852.
 * Event description: A user clicks on a CTA in a premium incentive of a blocked premium feature.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the blocked feature
 *
 * is_eligible - Type: bool. Desc: Is the user eligible to buy a premium plan
 *
 * is_premium - Type: bool. Desc: Is the tenant Premium or Free
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumBlocksIncentiveCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumBlocksIncentiveCtaClick = function (params) {
    return { evid: 1852, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbFeaturedArticlesRemoveArticleConfirmParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - selected article id
* @property {string} article_name - selected article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Featured articles - remove article confirm. Evid: 1119.
 * Event description: remove article "confirm" button clicked.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: selected article id
 *
 * article_name - Type: string. Desc: selected article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbFeaturedArticlesRemoveArticleConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbFeaturedArticlesRemoveArticleConfirm = function (params) {
    return { evid: 1119, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsFieldDeletedVerification2Params
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} field_name - field name
* @property {string} field_type - {text, drop-down...}
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - Field deleted (verification 2). Evid: 1407.
 * Event description: Delete field from fields manager (after typing "YES").

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: {text, drop-down...}
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 * @param {appSettingsTicketSettingsCustomFieldsFieldDeletedVerification2Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsFieldDeletedVerification2 = function (params) {
    return { evid: 1407, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicVoteForFeatureRequestParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - Article ID
* @property {GUID} category_id - Category ID
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - in case of a widget
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} tenant_id - Tenant ID
* @property {boolean} thumbs_up - {true, false}
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Vote for feature request. Evid: 2003.
 * Event description: Vote/un-vote for wish list (similar to evid 502 in src 4).

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: Article ID
 *
 * category_id - Type: guid. Desc: Category ID
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: in case of a widget
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: string. Desc: Tenant ID
 *
 * thumbs_up - Type: bool. Desc: {true, false}
 *
 * user_id - Type: guid.
 * @param {publicVoteForFeatureRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicVoteForFeatureRequest = function (params) {
    return { evid: 2003, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticlePublishSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - client_id
* @property {string} lang - answers language
* @property {GUID} parent_guid - category id
* @property {string} permission_level - User's permission level
* @property {string} source - {article page/categories page}
* @property {GUID} tenant_id - answers tenant id
* @property {number} ts - amount of time (milliseconds) since save process started
* @property {GUID} user_id - uuid
**/
/**
 * Name: App (KB) - Publish success. Evid: 1121.
 * Event description: Successfully publishing an article.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid. Desc: client_id
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: category id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {article page/categories page}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ts - Type: numeric. Desc: amount of time (milliseconds) since save process started
 *
 * user_id - Type: guid. Desc: uuid
 * @param {appKbEditArticlePublishSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticlePublishSuccess = function (params) {
    return { evid: 1121, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralWelcomeLightboxViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Answers tenant id
* @property {string} type - The type of the welcome message (Freemium, Trial, etc.)
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (General) - Welcome Lightbox - View. Evid: 1901.
 * Event description: The Answers welcome lightbox was viewed by the user. Event avaiable since 2018-10-11.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * type - Type: string. Desc: The type of the welcome message (Freemium, Trial, etc.)
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appGeneralWelcomeLightboxViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralWelcomeLightboxView = function (params) {
    return { evid: 1901, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appWasabiAdvancedReportsDeleteReportParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} reportName - null
* @property {GUID} tenant_id - answers tenant_id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Wasabi) - Advanced Reports - Delete report. Evid: 1332.
 * Event description: User deleted an existing report (non standard report)
after clicking on 'Yes, Delete'.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * reportName - Type: string.
 *
 * tenant_id - Type: guid. Desc: answers tenant_id
 *
 * user_id - Type: guid.
 * @param {appWasabiAdvancedReportsDeleteReportParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appWasabiAdvancedReportsDeleteReport = function (params) {
    return { evid: 1332, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerPurchaseSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {number} tts - Time since load started in ms
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Purchase Success. Evid: 1833.
 * Event description: User succeeds to purchase.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * tts - Type: numeric. Desc: Time since load started in ms
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerPurchaseSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerPurchaseSuccess = function (params) {
    return { evid: 1833, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamAddANewTeamClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Add a new team click. Evid: 1204.
 * Event description: Add a new group button clicked.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamAddANewTeamClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamAddANewTeamClick = function (params) {
    return { evid: 1204, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} marketingSignUpSignUpSuccessFirstStepParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - Answers client ID
* @property {number} campaign_id - DEPRECATE
* @property {string} locale - DEPRECATE
* @property {GUID} marketing_id - DEPRECATE
* @property {string} permission_level - DEPRECATE
* @property {string} referral_name - referral
* @property {Url} referral_url - referral
* @property {GUID} session_id - DEPRECATE
* @property {GUID} tenant_id - Tenant of the performing user
* @property {GUID} user_id - Answers uuid
* @property {GUID} wix_client_id - Wix client (Anonymous) ID
* @property {GUID} wix_user_id - wix user id
**/
/**
 * Name: Marketing (Sign Up) - Sign Up success - first step. Evid: 104.
 * Event description: success on first step of the sign up flow.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid. Desc: Answers client ID
 *
 * campaign_id - Type: numeric. Desc: DEPRECATE
 *
 * locale - Type: string. Desc: DEPRECATE
 *
 * marketing_id - Type: guid. Desc: DEPRECATE
 *
 * permission_level - Type: string. Desc: DEPRECATE
 *
 * referral_name - Type: string. Desc: referral
 *
 * referral_url - Type: url. Desc: referral
 *
 * session_id - Type: guid. Desc: DEPRECATE
 *
 * tenant_id - Type: guid. Desc: Tenant of the performing user
 *
 * user_id - Type: guid. Desc: Answers uuid
 *
 * wix_client_id - Type: guid. Desc: Wix client (Anonymous) ID
 *
 * wix_user_id - Type: guid. Desc: wix user id
 * @param {marketingSignUpSignUpSuccessFirstStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketingSignUpSignUpSuccessFirstStep = function (params) {
    return { evid: 104, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerOrderPreviewRenderedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {GUID} preview_id - ID of the order preview
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {number} tts - Time since load started in ms
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Order Preview Rendered. Evid: 1827.
 * Event description: Order preview is rendered.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * preview_id - Type: guid. Desc: ID of the order preview
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * tts - Type: numeric. Desc: Time since load started in ms
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerOrderPreviewRenderedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerOrderPreviewRendered = function (params) {
    return { evid: 1827, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSecondStepProductCheckboxCheckedParams
* @property {GUID} answers_brand_id - null
* @property {string} checked_product - checked product: KB, Ticketing (HD), Call center
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - plan price
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - monthly/yearly subscription
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Second step - Product checkbox checked. Evid: 1814.
 * Event description: Answers PP - Second step: user checked on one of the products checkboxes : KB/ Ticketing(HD)/ Call center. (custom as plan type)
for example:
checked_product: Call center
product_call_center=1
product_ticketing =0
product_knowledge_base=0.

 * answers_brand_id - Type: guid.
 *
 * checked_product - Type: string. Desc: checked product: KB, Ticketing (HD), Call center
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: plan price
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: monthly/yearly subscription
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerSecondStepProductCheckboxCheckedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSecondStepProductCheckboxChecked = function (params) {
    return { evid: 1814, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbCategoriesAddCategoryCancelParams
* @property {GUID} answers_brand_id - null
* @property {GUID} category_id - category_id
* @property {string} category_name - User's entered value for category (can be null)
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {GUID} parent_guid - If category - null, if subcategory - category's id
* @property {string} permission_level - User's permission level
* @property {string} source - {side bar/main screen}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Categories - Create category cancel click. Evid: 1113.
 * Event description: Create category --> click cancel.

 * answers_brand_id - Type: guid.
 *
 * category_id - Type: guid. Desc: category_id
 *
 * category_name - Type: string. Desc: User's entered value for category (can be null)
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * parent_guid - Type: guid. Desc: If category - null, if subcategory - category's id
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {side bar/main screen}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbCategoriesAddCategoryCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbCategoriesAddCategoryCancel = function (params) {
    return { evid: 1113, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTopBarNotificationIconClickedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} group_name - group name
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {string} source_tab - The location (source tab) of the user in the app when clicking on the icon
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Top bar) - Notification icon clicked. Evid: 1910.
 * Event description: Notification icon clicked from the top bar.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * group_name - Type: string. Desc: group name
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source_tab - Type: string. Desc: The location (source tab) of the user in the app when clicking on the icon
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTopBarNotificationIconClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTopBarNotificationIconClicked = function (params) {
    return { evid: 1910, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicSubmitTicketAttemptParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - null if form_source is = 1
* @property {GUID} client_id - null
* @property {string} description - Ticket content
* @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
* @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
* @property {boolean} is_attached - if there is an attachment
* @property {string} locale - Answers language
* @property {string} parent_url - widget's parent page
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral_url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} subject - Ticket subject
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: Public - "Submit Ticket" - attempt. Evid: 2510.
 * Event description: Clicking on "Submit ticket" button at the bottom of the ticket form
(similar to event 577 in source 4).

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: null if form_source is = 1
 *
 * client_id - Type: guid.
 *
 * description - Type: string. Desc: Ticket content
 *
 * form_source - Type: string. Desc: {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 *
 * is_after_suggestion - Type: bool. Desc: rather the user already clicked on a features article and clicked "No, I want to report my issue"
 *
 * is_attached - Type: bool. Desc: if there is an attachment
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: widget's parent page
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral_url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * subject - Type: string. Desc: Ticket subject
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid.
 * @param {publicSubmitTicketAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicSubmitTicketAttempt = function (params) {
    return { evid: 2510, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSecondStepUserUncheckedProductParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - Answers plan price
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - 1- if call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - 1- if knowledge base checkbox checked
* @property {boolean} product_ticketing - 1- if ticketing checkbox checked
* @property {string} subscription_type - Yearly / Monthly
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {string} unchecked_product - product that was unchecked
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Second step - User unchecked product. Evid: 1815.
 * Event description: Answers Package Picker - Second step - User unchecked product checkbox on Custom plan type: uncheck call center/uncheck knowledge base/uncheck ticketing.
for example:
product_call_center=0
product_ticketing =0
product_knowledge_base=0
and unchecked_product: Call center.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: Answers plan price
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: 1- if call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: 1- if knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: 1- if ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: Yearly / Monthly
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * unchecked_product - Type: string. Desc: product that was unchecked
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerSecondStepUserUncheckedProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSecondStepUserUncheckedProduct = function (params) {
    return { evid: 1815, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralInAppNotificationsClientEngagementParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} data - Json of Data related to the engagement. Examples: (1) If the engagement is "notification click" data will include notification_id, notification_type, notification_content etc (2) If the engagement is "send announcement click" data will include announcement title, content, type, recipients etc
* @property {string} engagement - What kind of engagement happened. Examples: (1) main notification button click (2) notification click (3) create announcement click (4) send announcement click
* @property {string} lang - Answers language according to the Account settings
* @property {GUID} role_id - Role ID of the engaging member
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - User ID of the engaging member
**/
/**
 * Name: App (General) - In-app Notifications - client engagement. Evid: 4902.
 * Event description: A generic event for the following clicks/engagements related to In-app notifications: (1) click on main notifications button to open the notification list, (2) click on notification (3) create announcement click,  (4) Send announcement click.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: Json of Data related to the engagement. Examples: (1) If the engagement is "notification click" data will include notification_id, notification_type, notification_content etc (2) If the engagement is "send announcement click" data will include announcement title, content, type, recipients etc
 *
 * engagement - Type: string. Desc: What kind of engagement happened. Examples: (1) main notification button click (2) notification click (3) create announcement click (4) send announcement click
 *
 * lang - Type: string. Desc: Answers language according to the Account settings
 *
 * role_id - Type: guid. Desc: Role ID of the engaging member
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the engaging member
 * @param {appGeneralInAppNotificationsClientEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralInAppNotificationsClientEngagement = function (params) {
    return { evid: 4902, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTicketsOneInboxDeleteAReplyCancelParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} content - reply's content
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} reply_id - reply id
* @property {string} reply_type - {team note/reply}
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} ticket_id - ticket id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Tickets / One Inbox) - Delete a reply cancel. Evid: 1014.
 * Event description: Click "Cancel" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * content - Type: string. Desc: reply's content
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * reply_id - Type: guid. Desc: reply id
 *
 * reply_type - Type: string. Desc: {team note/reply}
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * ticket_id - Type: guid. Desc: ticket id
 *
 * user_id - Type: guid.
 * @param {appTicketsOneInboxDeleteAReplyCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTicketsOneInboxDeleteAReplyCancel = function (params) {
    return { evid: 1014, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicCustomerPortalViewerPageLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {boolean} is_company_filtered - Relevant only for section_key = support requests list
* @property {boolean} is_language_filtered - Relevant only for section_key = support requests list
* @property {boolean} is_page_load_from_portal - Is the load of the ticket page is happening internally from the portal (True) or is it stand alone (False) - relevant only for section_key = Ticket page
* @property {boolean} is_reporter_filtered - Relevant only for section_key = support requests list
* @property {boolean} is_status_filtered - Relevant only for section_key = support requests list
* @property {boolean} is_user_ticket_ccd - Is the ticket viewer cc'd to the ticket? relevant only for section_key = Ticket page
* @property {boolean} is_user_ticket_reporter - Is the ticket viewer (user) also the ticket reporter? relevant only for section_key = Ticket page
* @property {string} lang - Answers language
* @property {boolean} page_has_contact_us_button - Does the contact us buttons are visible in the page (True or False)
* @property {boolean} page_has_custom_fields - If section_key = support requests - does custom fields column presented, if section_key = ticket page - does custom fields presented in the info panel
* @property {string} section_key - Support requests/followed articles/ticket page
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: Public (Customer Portal) - Viewer Page Load Success. Evid: 2401.
 * Event description: This Event is triggered every time Customer Portal viewer page is Loaded Successfully.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * is_company_filtered - Type: bool. Desc: Relevant only for section_key = support requests list
 *
 * is_language_filtered - Type: bool. Desc: Relevant only for section_key = support requests list
 *
 * is_page_load_from_portal - Type: bool. Desc: Is the load of the ticket page is happening internally from the portal (True) or is it stand alone (False) - relevant only for section_key = Ticket page
 *
 * is_reporter_filtered - Type: bool. Desc: Relevant only for section_key = support requests list
 *
 * is_status_filtered - Type: bool. Desc: Relevant only for section_key = support requests list
 *
 * is_user_ticket_ccd - Type: bool. Desc: Is the ticket viewer cc'd to the ticket? relevant only for section_key = Ticket page
 *
 * is_user_ticket_reporter - Type: bool. Desc: Is the ticket viewer (user) also the ticket reporter? relevant only for section_key = Ticket page
 *
 * lang - Type: string. Desc: Answers language
 *
 * page_has_contact_us_button - Type: bool. Desc: Does the contact us buttons are visible in the page (True or False)
 *
 * page_has_custom_fields - Type: bool. Desc: If section_key = support requests - does custom fields column presented, if section_key = ticket page - does custom fields presented in the info panel
 *
 * section_key - Type: string. Desc: Support requests/followed articles/ticket page
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {publicCustomerPortalViewerPageLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicCustomerPortalViewerPageLoadSuccess = function (params) {
    return { evid: 2401, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerWhatSInsideHoverParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} from_step - PP step user takes the action from (1 / 2 / 3)
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - What's Inside Hover. Evid: 1836.
 * Event description: User hovers on "What's Inside" - tip tool.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: numeric. Desc: PP step user takes the action from (1 / 2 / 3)
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerWhatSInsideHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerWhatSInsideHover = function (params) {
    return { evid: 1836, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerUserOpenedPpParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - upgrade origin component
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - User opened PP. Evid: 1811.
 * Event description: Answers PP - lightbox appears successfully.
First step - User select team size
Second Step -  User choose a plan and product.
Third step - User select subscription type..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerUserOpenedPpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerUserOpenedPp = function (params) {
    return { evid: 1811, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerGoBackToPreviousStepParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} from_step - PP step user takes the action from (1 / 2 / 3)
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Go Back to Previous Step. Evid: 1837.
 * Event description: User clicks button to go back to previous page.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: numeric. Desc: PP step user takes the action from (1 / 2 / 3)
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerGoBackToPreviousStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerGoBackToPreviousStep = function (params) {
    return { evid: 1837, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsTicketSettingsCustomFieldsNewFieldCreatedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} field_name - main field name (default lang)
* @property {string} field_type - {text, drop-down...}
* @property {string} lang - answers language
* @property {string} langs - checked languages
* @property {string} permission_level - User's permission level
* @property {string} source - {Fields manager, Widget contact form, Help center contact form}
* @property {GUID} tenant_id - tenant_id
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget id
* @property {string} widget_name - widget name
**/
/**
 * Name: App (Settings) - Ticket Settings - Custom Fields - New field created. Evid: 1401.
 * Event description: Submit the form for the new field.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * field_name - Type: string. Desc: main field name (default lang)
 *
 * field_type - Type: string. Desc: {text, drop-down...}
 *
 * lang - Type: string. Desc: answers language
 *
 * langs - Type: string. Desc: checked languages
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * source - Type: string. Desc: {Fields manager, Widget contact form, Help center contact form}
 *
 * tenant_id - Type: guid. Desc: tenant_id
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget id
 *
 * widget_name - Type: string. Desc: widget name
 * @param {appSettingsTicketSettingsCustomFieldsNewFieldCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsTicketSettingsCustomFieldsNewFieldCreated = function (params) {
    return { evid: 1401, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicVoteForArticleParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - Article ID
* @property {GUID} category_id - Category ID
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} parent_url - parent_url (widget)
* @property {string} referral_name - referral_name
* @property {Url} referral_url - referral url
* @property {GUID} source_id - source_id
* @property {string} source_name - source_name
* @property {string} source_type - source_type
* @property {string} tenant_id - Tenant ID
* @property {boolean} thumbs_up - {true, false}
* @property {GUID} user_id - null
**/
/**
 * Name: Public - Vote for an article. Evid: 2002.
 * Event description: Click on "Thumbs up/down" (similar to evid 501 in src 4).

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: Article ID
 *
 * category_id - Type: guid. Desc: Category ID
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * parent_url - Type: string. Desc: parent_url (widget)
 *
 * referral_name - Type: string. Desc: referral_name
 *
 * referral_url - Type: url. Desc: referral url
 *
 * source_id - Type: guid. Desc: source_id
 *
 * source_name - Type: string. Desc: source_name
 *
 * source_type - Type: string. Desc: source_type
 *
 * tenant_id - Type: string. Desc: Tenant ID
 *
 * thumbs_up - Type: bool. Desc: {true, false}
 *
 * user_id - Type: guid.
 * @param {publicVoteForArticleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicVoteForArticle = function (params) {
    return { evid: 2002, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - Answers product price
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - Yearly/monthly
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - User closed upgrade success light box. Evid: 1819.
 * Event description: Answers PP last step:  upgrade success lightbox closed.
Method is for user closing action: user click on okay button /click outside of the lightbox.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: Answers product price
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: Yearly/monthly
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerUserClosedUpgradeSuccessLightBox = function (params) {
    return { evid: 1819, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerProceedToCheckoutClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} from_step - last step on pp the user was before this event
* @property {string} origin - upgrade origin component
* @property {number} plan_price - Answers plan price
* @property {string} plan_type - Custom plan/Unlimited plan
* @property {boolean} product_call_center - call center checkbox checked
* @property {boolean} product_chat - chat checkbox checked
* @property {boolean} product_knowledge_base - knowledge base checkbox checked
* @property {boolean} product_ticketing - ticketing checkbox checked
* @property {string} subscription_type - monthly/ yearly
* @property {string} team_size - max team size the user selected
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Proceed to checkout click. Evid: 1818.
 * Event description: Answers PP last step.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * from_step - Type: string. Desc: last step on pp the user was before this event
 *
 * origin - Type: string. Desc: upgrade origin component
 *
 * plan_price - Type: numeric. Desc: Answers plan price
 *
 * plan_type - Type: string. Desc: Custom plan/Unlimited plan
 *
 * product_call_center - Type: bool. Desc: call center checkbox checked
 *
 * product_chat - Type: bool. Desc: chat checkbox checked
 *
 * product_knowledge_base - Type: bool. Desc: knowledge base checkbox checked
 *
 * product_ticketing - Type: bool. Desc: ticketing checkbox checked
 *
 * subscription_type - Type: string. Desc: monthly/ yearly
 *
 * team_size - Type: string. Desc: max team size the user selected
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid. Desc: answers user ID
 * @param {appPremiumPackagePickerProceedToCheckoutClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerProceedToCheckoutClick = function (params) {
    return { evid: 1818, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appTeamTeamMemberInvitationSentButtonClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {number} count_admins - count admins added
* @property {number} count_agents - count agents added
* @property {string} lang - answers lang
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (Team) - Team member invitation sent (button click). Evid: 1203.
 * Event description: Click on the "send" button after adding group members.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * count_admins - Type: numeric. Desc: count admins added
 *
 * count_agents - Type: numeric. Desc: count agents added
 *
 * lang - Type: string. Desc: answers lang
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appTeamTeamMemberInvitationSentButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appTeamTeamMemberInvitationSentButtonClick = function (params) {
    return { evid: 1203, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appGeneralFtueVideoLightboxViewParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} feature - Name of the feature the lightbox is shown in
* @property {GUID} tenant_id - Answers tenant id
* @property {GUID} user_id - Answers User ID
**/
/**
 * Name: App (General) - FTUE Video Lightbox - View. Evid: 1947.
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was viewed by the user.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * feature - Type: string. Desc: Name of the feature the lightbox is shown in
 *
 * tenant_id - Type: guid. Desc: Answers tenant id
 *
 * user_id - Type: guid. Desc: Answers User ID
 * @param {appGeneralFtueVideoLightboxViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGeneralFtueVideoLightboxView = function (params) {
    return { evid: 1947, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbEditArticleClickSaveButtonParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - relevant article id
* @property {string} article_name - relevant article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Edit article - Click "Save" button. Evid: 1099.
 * Event description: Click "Save" button.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: relevant article id
 *
 * article_name - Type: string. Desc: relevant article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbEditArticleClickSaveButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbEditArticleClickSaveButton = function (params) {
    return { evid: 1099, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} answersBannerClickParams
* @property {string} banner_text - banner text
* @property {GUID} answers_brand_id - null
* @property {string} banner_language - banner language
* @property {string} banner_name - banner name
* @property {string} clicked_item_type - what was clicked on (link/close etc.)
* @property {string} clicked_text - The text that was clicked on
* @property {string} clicked_url - Destination url the link takes the user to
* @property {GUID} client_id - null
* @property {string} lang - Answers language
* @property {GUID} tenant_id - null
* @property {GUID} user_id - null
**/
/**
 * Name: Answers Banner Click. Evid: 4909.
 * Event description: Fired when a user clicks a banner in Answers.

 * banner_text - Type: string. Desc: banner text
 *
 * answers_brand_id - Type: guid.
 *
 * banner_language - Type: string. Desc: banner language
 *
 * banner_name - Type: string. Desc: banner name
 *
 * clicked_item_type - Type: string. Desc: what was clicked on (link/close etc.)
 *
 * clicked_text - Type: string. Desc: The text that was clicked on
 *
 * clicked_url - Type: string. Desc: Destination url the link takes the user to
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: Answers language
 *
 * tenant_id - Type: guid.
 *
 * user_id - Type: guid.
 * @param {answersBannerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var answersBannerClick = function (params) {
    return { evid: 4909, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingPageLoadFailParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} reason - Reason of failure
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing -  Page Load Fail. Evid: 1458.
 * Event description: The Billing page was successfully uploaded..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * reason - Type: string. Desc: Reason of failure
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingPageLoadFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingPageLoadFail = function (params) {
    return { evid: 1458, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {GUID} tenant_id - Answers tenant ID
* @property {number} tts - Time since load started in ms
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Load Success. Evid: 1822.
 * Event description: User opens the Package Picker and it loads successfully.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * tts - Type: numeric. Desc: Time since load started in ms
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerLoadSuccess = function (params) {
    return { evid: 1822, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appKbFeaturedArticlesRemoveArticleCancelParams
* @property {GUID} answers_brand_id - null
* @property {GUID} article_id - selected article id
* @property {string} article_name - selected article name
* @property {GUID} client_id - null
* @property {string} lang - answers language
* @property {string} permission_level - User's permission level
* @property {GUID} tenant_id - answers tenant id
* @property {GUID} user_id - null
**/
/**
 * Name: App (KB) - Featured articles - remove article cancel. Evid: 1120.
 * Event description: remove article "cancel" button clicked.

 * answers_brand_id - Type: guid.
 *
 * article_id - Type: guid. Desc: selected article id
 *
 * article_name - Type: string. Desc: selected article name
 *
 * client_id - Type: guid.
 *
 * lang - Type: string. Desc: answers language
 *
 * permission_level - Type: string. Desc: User's permission level
 *
 * tenant_id - Type: guid. Desc: answers tenant id
 *
 * user_id - Type: guid.
 * @param {appKbFeaturedArticlesRemoveArticleCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appKbFeaturedArticlesRemoveArticleCancel = function (params) {
    return { evid: 1120, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appPremiumPackagePickerSelectPackageParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} origin - Upgrade origin component
* @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
* @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
* @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
* @property {GUID} tenant_id - Answers tenant ID
* @property {GUID} user_id - Answers user ID
**/
/**
 * Name: App (Premium) - Package Picker - Select Package. Evid: 1824.
 * Event description: User selects premium package - CTA click (Unlimited / Multi-Channel / Self-Service / Call Center).

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * origin - Type: string. Desc: Upgrade origin component
 *
 * package_id - Type: string. Desc: ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 *
 * payment_cycle - Type: string. Desc: Subscription cycle (monthly / yearly / two_years)
 *
 * team_size - Type: numeric. Desc: Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * tenant_id - Type: guid. Desc: Answers tenant ID
 *
 * user_id - Type: guid. Desc: Answers user ID
 * @param {appPremiumPackagePickerSelectPackageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPremiumPackagePickerSelectPackage = function (params) {
    return { evid: 1824, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} publicWismoChatbotStepReachedParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} data - json formatted string, containing all info on the current chat bot step, including step id, type, ticket id if created, etc.
* @property {GUID} session_id - wismo chat bot session id
* @property {string} tenant_id - null
* @property {string} user_device_type - the device type of the user - Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile.
* @property {GUID} user_id - null
* @property {GUID} widget_id - widget_id
**/
/**
 * Name: Public (Wismo chatbot) - step reached. Evid: 2260.


 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * data - Type: string. Desc: json formatted string, containing all info on the current chat bot step, including step id, type, ticket id if created, etc.
 *
 * session_id - Type: guid. Desc: wismo chat bot session id
 *
 * tenant_id - Type: string.
 *
 * user_device_type - Type: string. Desc: the device type of the user - Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile.
 *
 * user_id - Type: guid.
 *
 * widget_id - Type: guid. Desc: widget_id
 * @param {publicWismoChatbotStepReachedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publicWismoChatbotStepReached = function (params) {
    return { evid: 2260, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appMenuItemClickParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {string} locale - Answers language
* @property {string} menu_item_name - the item the user selected from the side menu - main selection {Home, Articles, Tickets, settings, widgets, members, insights}
* @property {string} permission_level - Users's permission level
* @property {string} source_tab - The location (source tab) of the user in the app when clicking on the item
* @property {GUID} tenant_id - tenant of the performing user
* @property {GUID} user_id - null
**/
/**
 * Name: App - Menu item click. Evid: 1000.
 * Event description: click any of the menu items in Answers app left menu.

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * locale - Type: string. Desc: Answers language
 *
 * menu_item_name - Type: string. Desc: the item the user selected from the side menu - main selection {Home, Articles, Tickets, settings, widgets, members, insights}
 *
 * permission_level - Type: string. Desc: Users's permission level
 *
 * source_tab - Type: string. Desc: The location (source tab) of the user in the app when clicking on the item
 *
 * tenant_id - Type: guid. Desc: tenant of the performing user
 *
 * user_id - Type: guid.
 * @param {appMenuItemClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appMenuItemClick = function (params) {
    return { evid: 1000, src: 77, endpoint: 'wix-answers', params: params };
};
/**
* @typedef {Object} appSettingsBillingPageLoadSuccessParams
* @property {GUID} answers_brand_id - null
* @property {GUID} client_id - null
* @property {GUID} tenant_id - Tenant ID
* @property {GUID} user_id - User ID of the member
**/
/**
 * Name: App (Settings) - Billing -  Page Load Success. Evid: 1457.
 * Event description: The Billing page was successfully uploaded..

 * answers_brand_id - Type: guid.
 *
 * client_id - Type: guid.
 *
 * tenant_id - Type: guid. Desc: Tenant ID
 *
 * user_id - Type: guid. Desc: User ID of the member
 * @param {appSettingsBillingPageLoadSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSettingsBillingPageLoadSuccess = function (params) {
    return { evid: 1457, src: 77, endpoint: 'wix-answers', params: params };
};
//# sourceMappingURL=index.js.map